export default {
  'pages.covenantDevice.mac': 'MAC地址',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC地址',
  'pages.covenantDevice.cardTitle': '协约设备管理',
  'pages.unbindDevice.cardTitle': '设备解绑',
  'pages.whiteList.cardTitle': '白名单管理',
  'pages.admin.whitelist.mac': 'MAC地址',
  'pages.covenantDevice.operations': '操作',
  'pages.covenantDevice.expireTime': '到期时间',
  'pages.covenantDevice.updateTime': '更新时间',

  'pages.admin.ops.logViewer.previewTitle': '日志预览',
  'pages.admin.ops.logViewer.fileName': '文件名：',
  'pages.admin.ops.logViewer.lineCount': '行数：',
  'pages.admin.ops.logViewer.previewBtn': '预览',
  'pages.admin.ops.logViewer.noContent': '暂无内容',

  'pages.admin.feedback.title': '问题反馈管理',
  'pages.admin.feedback.id': 'ID',
  'pages.admin.feedback.userId': '用户ID',
  'pages.admin.feedback.faultType': '故障类型',
  'pages.admin.feedback.faultType.offline': '设备离线/连接不上',
  'pages.admin.feedback.faultType.hardware': '硬件损坏/外观破损',
  'pages.admin.feedback.faultType.function': '功能异常/操作无响应',
  'pages.admin.feedback.faultType.firmware': '固件升级失败',
  'pages.admin.feedback.faultType.other': '其他问题',
  'pages.admin.feedback.problemDesc': '问题描述',
  'pages.admin.feedback.deviceModel': '设备型号',
  'pages.admin.feedback.deviceMac': '设备MAC',
  'pages.admin.feedback.contact': '联系方式',
  'pages.admin.feedback.email': '邮箱',
  'pages.admin.feedback.phone': '电话',
  'pages.admin.feedback.isSolved': '处理状态',
  'pages.admin.feedback.isSolved.pending': '未处理',
  'pages.admin.feedback.isSolved.solved': '已解决',
  'pages.admin.feedback.createTime': '提交时间',
  'pages.admin.feedback.updateTime': '更新时间',
  'pages.admin.feedback.operations': '操作',
  'pages.admin.feedback.detail': '详情',
  'pages.admin.feedback.detail.title': '反馈详情',
  'pages.admin.feedback.markSolved': '标记已解决',
  'pages.admin.feedback.markPending': '标记未处理',
  'pages.admin.feedback.process.success': '处理状态已更新',
  'pages.admin.feedback.process.failed': '更新失败',
  'pages.admin.feedback.delete': '删除',
  'pages.admin.feedback.delete.confirm': '确定要删除该反馈吗？',
  'pages.admin.feedback.delete.success': '删除成功',
  'pages.admin.feedback.delete.failed': '删除失败',

  'pages.admin.guardReport.title': '守护日报',
  'pages.admin.guardReport.dailyStats': '当日拦截统计',
  'pages.admin.guardReport.refresh': '刷新',
  'pages.admin.guardReport.loadFail': '加载日报失败',
  'pages.admin.guardReport.stat.inputBlocked': '输入拦截',
  'pages.admin.guardReport.stat.outputBlocked': '输出拦截',
  'pages.admin.guardReport.stat.cycleExceeded': '周期超限',
  'pages.admin.guardReport.stat.dailyExceeded': '日限超限',
  'pages.admin.guardReport.stat.softRemind': '软提醒',
  'pages.admin.guardReport.stat.adminGrant': '管理豁免',
  'pages.admin.guardReport.feedbackTitle': '词表误杀反馈（待审）',
  'pages.admin.guardReport.feedbackLoadFail': '加载反馈失败',
  'pages.admin.guardReport.deviceId': '设备',
  'pages.admin.guardReport.band': '分龄',
  'pages.admin.guardReport.direction': '方向',
  'pages.admin.guardReport.hitWord': '命中词',
  'pages.admin.guardReport.textSnippet': '文本片段',
  'pages.admin.guardReport.reason': '反馈原因',
  'pages.admin.guardReport.status': '状态',
  'pages.admin.guardReport.operations': '操作',
  'pages.admin.guardReport.accept': '通过',
  'pages.admin.guardReport.reject': '驳回',
  'pages.admin.guardReport.reviewSuccess': '已更新反馈状态',
  'pages.admin.guardReport.reviewFail': '更新失败',

  'pages.deviceBound.safety.antiAddiction': '防沉迷',
'pages.deviceBound.safety.antiAddictionTip':
     '防沉迷按服务器配置时区统计（默认北京时间），每天凌晨 0 点重新计算；设备和手机所在地时区不影响清零。达到当天周期上限后休息，休息状态也按服务器时区的新一天重新开始。',
  'pages.deviceBound.safety.lock.daily': '今日已满',
  'pages.deviceBound.safety.lock.cycleRest': '休息中',
  'pages.deviceBound.safety.dailyExhausted': '今日已满，剩余 {duration}',
  'pages.deviceBound.safety.remainMinutes': '剩余 {min} 分钟',
  'pages.deviceBound.safety.remainClock': '剩余 {clock}',
  'pages.deviceBound.safety.nearRest': '临近休息',
  'pages.deviceBound.safety.remainActiveMinutes': '约剩 {min} 分钟',
  'pages.deviceBound.safety.cycleUsedMinutes': '本周期有效对话 {min} 分钟',
  'pages.deviceBound.safety.cycleUsedOfLimit': '本周期有效对话 {used}/{limit} 分钟',
  'pages.deviceBound.safety.normal': '正常',

  'pages.admin.devices': '设备管理',
  'pages.admin.unbindDevice': '设备解绑',
  'pages.admin.deviceManage': '设备管理',
  'pages.deviceBound.title': '绑定设备列表',
  'pages.deviceBound.username': '所属用户',
  'pages.deviceBound.username.placeholder': '请输入用户账号',
  'pages.deviceBound.tenantName': '所属企业',
  'pages.deviceBound.tenantName.placeholder': '请输入企业名称或编码',
  'pages.deviceBound.boardType': '固件型号',
  'pages.deviceBound.version': '版本',
  'pages.deviceBound.activatedAt': '激活时间',
  'pages.deviceBound.online': '在线状态',
  'pages.deviceBound.online.on': '在线',
  'pages.deviceBound.online.off': '离线',
  'pages.deviceBound.productName': '产品名称',
  'pages.deviceBound.operations': '操作',
  'pages.deviceBound.unbind': '一键解绑',
  'pages.deviceBound.unbind.confirm': '确定要解绑该设备吗？解绑后设备需要重新激活绑定。',
  'pages.deviceBound.unbind.success': '解绑成功',
  'pages.deviceBound.unbind.fail': '解绑失败',
  'pages.tenant.deviceBound.title': '设备管理',
  'pages.deviceBound.unbind.confirm.tenant':
    '确定要解绑该设备吗？解绑后需重新激活绑定（企业账号每日最多解绑 10 次）。',
  'pages.deviceBound.usage.action': '使用详情',
  'pages.deviceBound.usage.title': '使用详情',
  'pages.deviceBound.usage.username': '绑定用户账号',
  'pages.deviceBound.usage.tokensToday': '当天 Token 使用量',
  'pages.deviceBound.usage.tokens7Days': '7 天 Token 使用量',
  'pages.deviceBound.usage.tokens30Days': '30 天 Token 使用量',
  'pages.deviceBound.usage.tokensTotal': '总计 Token 使用量',
  'pages.deviceBound.usage.dialogueTotal': '总计对话次数',
  'pages.deviceBound.usage.loadFail': '加载使用详情失败',
  'pages.deviceBound.agent.action': 'Agents详情',
  'pages.deviceBound.agent.title': 'Agents 详情',
  'pages.deviceBound.agent.noAgent': '该设备未绑定智能体',
  'pages.deviceBound.agent.loadFail': '加载智能体详情失败',
'pages.deviceBound.safety.action': '守护',
   'pages.deviceBound.aaUsage.action': '用量',
   'pages.deviceBound.more.action': '更多',
   'pages.deviceBound.safety.title': '设备守护',
  'pages.deviceBound.safety.minorBand': '分龄',
  'pages.deviceBound.safety.band.off': '关闭',
  'pages.deviceBound.safety.band.teen': '青少年',
  'pages.deviceBound.safety.band.child': '儿童',
  'pages.deviceBound.safety.effectiveBand': '生效分龄',
  'pages.deviceBound.safety.sources': '分档来源',
  'pages.deviceBound.safety.source.agent': '智能体',
  'pages.deviceBound.safety.source.device': '设备',
  'pages.deviceBound.safety.source.withBand': '{side}：{band}',
  'pages.deviceBound.safety.agentBand': '智能体分龄',
  'pages.deviceBound.safety.deviceBandCurrent': '设备分龄（当前）',
  'pages.deviceBound.safety.deviceBandEdit': '设置设备分龄',
  'pages.deviceBound.safety.restStatus': '防沉迷状态',
  'pages.deviceBound.safety.resting': '休息中，剩余 {duration}',
  'pages.deviceBound.safety.notRestricted': '未限制',
'pages.deviceBound.safety.cycleUsage': '今日周期有效对话',
   'pages.deviceBound.safety.cycleUsageTip':
     '按服务器配置时区统计，每天凌晨 0 点重新计算；设备和手机所在地时区不影响清零。达到周期上限后进入休息。',
  'pages.deviceBound.safety.dailyUsage': '当日有效对话',
'pages.deviceBound.safety.dailyUsageTip':
     '按服务器配置时区自然日累计（默认北京时间）。仅启用日限时作为当天总量硬顶，满后锁到服务器时区次日 0 点。',
   'pages.deviceBound.safety.usageRuleTip':
     '用量说明：周期和日限都按服务器配置时区统计，每天凌晨 0 点重新计算；设备和手机所在地时区不影响清零。',
  'pages.deviceBound.safety.grantStatus': '豁免状态',
  'pages.deviceBound.safety.grantNone': '无豁免',
  'pages.deviceBound.safety.grantActive': '豁免中，至 {until}',
  'pages.deviceBound.safety.grantTag': '豁免中',
  'pages.deviceBound.safety.grantRounds': '，剩余 {rounds} 回合',
  'pages.deviceBound.safety.unlock': '解锁',
  'pages.deviceBound.safety.unlockTitle': '发放解锁豁免',
  'pages.deviceBound.safety.unlockSeconds': '追加时长（秒）',
  'pages.deviceBound.safety.unlockReason': '解锁原因',
  'pages.deviceBound.safety.unlockReasonRequired': '请填写解锁原因',
  'pages.deviceBound.safety.unlockSuccess': '已发放解锁豁免',
  'pages.deviceBound.safety.unlockFail': '解锁失败',
  'pages.deviceBound.safety.override': '策略覆盖',
  'pages.deviceBound.safety.overrideMode': '覆盖模式',
  'pages.deviceBound.safety.override.hint':
    '只改本机防沉迷时长规则，不影响分龄内容拦截。优先级：自定义 > 儿童 profile > 全局。',
  'pages.deviceBound.safety.override.inherit': '继承',
  'pages.deviceBound.safety.override.inheritDesc':
    '默认。跟系统全局防沉迷走；儿童档时用更严儿童时长（默认约 60 分钟聊 / 30 分钟休）。',
  'pages.deviceBound.safety.override.disable': '关闭防沉迷',
  'pages.deviceBound.safety.override.disableDesc':
    '本机不计时长、不强制休息、不卡日限。分龄词表与提示词守护仍然生效。',
  'pages.deviceBound.safety.override.custom': '自定义',
  'pages.deviceBound.safety.override.customDesc':
    '为本机单独设周期上限、休息时长与日限，覆盖全局与儿童 profile。',
  'pages.deviceBound.safety.override.cycle': '周期上限（分钟）',
  'pages.deviceBound.safety.override.rest': '休息时长（分钟）',
  'pages.deviceBound.safety.override.daily': '日上限（分钟）',
  'pages.deviceBound.safety.override.dailyTip': '填 0 表示不限制当日总时长',
  'pages.deviceBound.safety.override.howto':
    '怎么选：一般用「继承」；临时放宽时长用「关闭防沉迷」或临时放行；要单独定节奏用「自定义」。',
  'pages.deviceBound.safety.overrideSave': '保存覆盖',
  'pages.deviceBound.safety.overrideSaveTip':
    '此按钮只保存「策略覆盖」。上方的设备分龄请点页脚「保存分龄」；两者互不影响，需分别保存。',
  'pages.deviceBound.safety.overrideSuccess': '策略覆盖已保存',
  'pages.deviceBound.safety.overrideFail': '保存覆盖失败',
  'pages.deviceBound.safety.saveBand': '保存分龄',
  'pages.deviceBound.safety.saveBandTip':
    '页脚「保存分龄」只写入设备分龄档；策略覆盖须点上方「保存覆盖」才会生效。',
  'pages.deviceBound.safety.hint':
    '生效分龄为智能体与设备取更严；仅修改本设备档，不影响智能体全局设置。保存分龄与保存覆盖是两套操作，需分别点击对应按钮。防沉迷「本周期」按休息周期累计（默认约 2 小时可聊后休息约 30 分钟），不是自然日，过零点不会自动清零；「当日」才是自然日用量。',
  'pages.deviceBound.safety.loadFail': '加载守护状态失败',
  'pages.deviceBound.safety.saveSuccess': '已保存设备分龄设置',
  'pages.deviceBound.safety.saveFail': '保存失败',
  'pages.unbindDevice.titleAdmin': '设备解绑（需管理员权限）',
  'pages.unbindDevice.inputPlaceholder': '请输入设备ID',
  'pages.unbindDevice.unbind': '解绑',
  'pages.unbindDevice.unbinding': '解绑中...',
  'pages.unbindDevice.success': '解绑成功',
  'pages.unbindDevice.fail': '解绑失败',
  'pages.layouts.userLayout.title': '管理控制台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
  'pages.register': '新用户注册',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名或手机号',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.welcome.defaultTitle': '管理后台',
  'pages.welcome.guest': '用户',
  'pages.welcome.greeting.morning': '早上好',
  'pages.welcome.greeting.afternoon': '下午好',
  'pages.welcome.greeting.evening': '晚上好',
  'pages.welcome.greeting.night': '夜深了',
  'pages.welcome.heroTitle': '欢迎使用 {title}',
  'pages.welcome.role.admin': '系统管理员',
  'pages.welcome.role.observer': '观察员',
  'pages.welcome.role.enterprise': '企业账号',
  'pages.welcome.role.user': '普通用户',
  'pages.welcome.quickActions': '快捷入口',
  'pages.welcome.action.agents.title': '智能体管理',
  'pages.welcome.action.agents.desc': '创建与管理 AI 智能体，绑定设备',
  'pages.welcome.action.knowledge.title': '知识库',
  'pages.welcome.action.knowledge.desc': '上传文档，为智能体提供专属知识',
  'pages.welcome.action.voiceClone.title': '声音克隆',
  'pages.welcome.action.voiceClone.desc': '定制专属音色，让对话更有个性',
  'pages.welcome.action.dashboard.title': '系统概览',
  'pages.welcome.action.dashboard.desc': '查看用户、设备与系统运行状态',
  'pages.welcome.action.userManage.title': '用户管理',
  'pages.welcome.action.userManage.desc': '管理系统用户与权限配置',
  'pages.welcome.action.settings.title': '系统设置',
  'pages.welcome.action.settings.desc': '配置模型、参数与全局选项',
  'pages.welcome.action.tenant.title': '企业信息',
  'pages.welcome.action.tenant.desc': '查看与维护企业资料及授权',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // Agents 页面相关文本
  'pages.agents.search.placeholder': '搜索智能体',
  'pages.agents.create.button': '新建智能体',
  'pages.agents.addDevice.button': '添加设备',
  'pages.agents.create.modal.title': '新建智能体',
  'pages.agents.create.modal.nameLabel': '智能体名称',
  'pages.agents.create.modal.placeholder': '请输入智能体名称',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': '角色音色',
  'pages.agents.card.languageModel': '语言模型',
  'pages.agents.card.lastChat': '最近对话',
  'pages.agents.card.conversationId': '会话ID',
  'pages.agents.card.clearConversation': '清除会话ID',
  'pages.agents.card.clearConversation.success': '会话ID已清除',
  'pages.agents.card.clearConversation.error': '清除会话ID失败',
  'pages.agents.card.configRole': '配置角色',
  'pages.agents.card.configMemory': '配置记忆',
  'pages.agents.card.voiceRecognition': '声纹识别',
  'pages.agents.card.voiceRecognition.developing': '功能开发中，敬请期待',
  'pages.agents.card.historyDialog': '历史对话',
  'pages.agents.card.manageDevice': '管理设备',
  'pages.agents.card.addDevice': '添加设备',
  'pages.agents.loading': '加载智能体列表中...',
  'pages.agents.reload': '重新加载',
  'pages.agents.empty.title': '暂无智能体',
  'pages.agents.empty.createFirst': '创建第一个智能体',
  'pages.agents.delete.title': '确定删除智能体',
  'pages.agents.delete.content': '删除智能体后，该智能体有关配置（包括设备相关的对话记录）将无法恢复。确定删除吗？',
  'pages.agents.delete.confirm': '确认删除',
  'pages.agents.fetch.error': '获取智能体列表失败',
  'pages.agents.network.error': '网络错误，请稍后重试',
  'pages.agents.speed.patient': '耐心',
  'pages.agents.speed.normal': '正常',
  'pages.agents.speed.fast': '快速',
  'pages.agents.lastChat.none': '无',
  'pages.agents.language.chinese': '中文',
  'pages.agents.loading.tts.error': '加载TTS音色失败',
  'pages.agents.loading.llm.error': '加载LLM提供者失败',
  'pages.agents.sort.id': '按ID排序',
  'pages.agents.sort.updatedAt': '按最近修改',
  'pages.agents.sort.lastConversationAt': '按最近对话',

  // Register 页面相关文本
  'pages.register.title': '注册',
  'pages.register.form.title': '注册新账户',
  'pages.register.submit': '注册',
  'pages.register.username.placeholder': '请输入用户名',
  'pages.register.username.required': '请输入用户名！',
  'pages.register.username.min': '用户名至少3个字符',
  'pages.register.phone.placeholder': '请输入手机号',
  'pages.register.phone.required': '请输入手机号！',
  'pages.register.phone.invalid': '请输入有效的手机号！',
  'pages.register.smsCode.placeholder': '请输入短信验证码',
  'pages.register.smsCode.required': '请输入短信验证码！',
  'pages.register.smsCode.length': '验证码为6位数字',
  'pages.register.smsCode.get': '获取验证码',
  'pages.register.smsCode.sent': '验证码已发送',
  'pages.register.email.placeholder': '请输入邮箱',
  'pages.register.email.optionalPlaceholder': '邮箱（选填）',
  'pages.register.email.required': '请输入邮箱！',
  'pages.register.email.invalid': '请输入有效的邮箱地址！',
  'pages.register.phone.tab': '手机号注册',
  'pages.register.email.tab': '邮箱注册',
  'pages.register.emailCode.placeholder': '请输入邮箱验证码',
  'pages.register.emailCode.required': '请输入邮箱验证码！',
  'pages.register.emailCode.length': '验证码为6位数字',
  'pages.register.emailCode.get': '获取验证码',
  'pages.register.emailCode.sent': '验证码已发送',
  'pages.register.emailCode.sendFailed': '发送失败',
  'pages.register.phone.optionalPlaceholder': '手机号（选填）',
  'pages.register.backToLogin': '已有账号？去登录',
  'pages.register.password.placeholder': '请输入密码',
  'pages.register.password.required': '请输入密码！',
  'pages.register.password.min': '密码至少6个字符',
  'pages.register.password.pattern': '密码必须包含大小写字母和数字',
  'pages.register.confirmPassword.placeholder': '请确认密码',
  'pages.register.confirmPassword.required': '请确认密码！',
  'pages.register.confirmPassword.min': '密码至少6个字符',
  'pages.register.error.passwordMismatch': '两次输入的密码不一致',
  'pages.register.error.registerFailed': '注册失败，请重试！',
  'pages.register.success': '注册成功！',
  'pages.register.phone.onlyChinaHint': ' ',


  // Login 页面相关文本
  'pages.login.title': 'Anime AI Chat 管理控制台',
  'pages.login.actionIcons.notImplemented': '暂未实现，敬请期待',
  'pages.login.mobile.captchaError': '验证码错误',
  'pages.login.captcha.success': '获取验证码成功！验证码为：1234',
  'pages.login.forgotPassword.contactAdmin': '请联系管理员',
  'pages.login.mobile.notAvailable': '此功能暂未开放，请使用账户密码登录',

  // ForgotPassword 页面
  'pages.forgotPassword.title': '忘记密码',
  'pages.forgotPassword.form.title': '重置密码',
  'pages.forgotPassword.form.subtitle': '通过绑定手机号或邮箱验证后设置新密码',
  'pages.forgotPassword.mode.phone': '手机号',
  'pages.forgotPassword.mode.email': '邮箱',
  'pages.forgotPassword.submit': '确认重置',
  'pages.forgotPassword.phone.placeholder': '请输入注册手机号',
  'pages.forgotPassword.phone.required': '请输入手机号！',
  'pages.forgotPassword.phone.invalid': '请输入有效的手机号！',
  'pages.forgotPassword.smsCode.placeholder': '请输入短信验证码',
  'pages.forgotPassword.smsCode.required': '请输入短信验证码！',
  'pages.forgotPassword.smsCode.length': '验证码为6位数字',
  'pages.forgotPassword.smsCode.get': '获取验证码',
  'pages.forgotPassword.smsCode.sent': '验证码已发送',
  'pages.forgotPassword.email.placeholder': '请输入注册邮箱',
  'pages.forgotPassword.email.required': '请输入邮箱！',
  'pages.forgotPassword.email.invalid': '请输入有效的邮箱！',
  'pages.forgotPassword.emailCode.placeholder': '请输入邮箱验证码',
  'pages.forgotPassword.emailCode.required': '请输入邮箱验证码！',
  'pages.forgotPassword.emailCode.length': '验证码为6位数字',
  'pages.forgotPassword.emailCode.get': '获取验证码',
  'pages.forgotPassword.emailCode.sent': '验证码已发送至邮箱',
  'pages.forgotPassword.newPassword.placeholder': '请输入新密码',
  'pages.forgotPassword.newPassword.required': '请输入新密码！',
  'pages.forgotPassword.newPassword.min': '密码至少6个字符',
  'pages.forgotPassword.confirmPassword.placeholder': '请确认新密码',
  'pages.forgotPassword.confirmPassword.required': '请确认新密码！',
  'pages.forgotPassword.error.passwordMismatch': '两次输入的密码不一致',
  'pages.forgotPassword.error.resetFailed': '重置密码失败，请重试',
  'pages.forgotPassword.success': '密码重置成功，请使用新密码登录',
  'pages.forgotPassword.backToLogin': '返回登录',

  // SystemConfig 页面相关文本
  'pages.systemConfig.quickReply': '快速回复',
  'pages.systemConfig.useShortTermMemory': '短期记忆',
  'pages.systemConfig.useShortTermMemory.desc': '开启后，系统使用短期记忆机制，每轮对话后更新短期记忆。关闭则不使用短期记忆。',

  // AgentMemorySetting 页面相关文本
  'pages.agentMemorySetting.title': '配置记忆',
  'pages.agentMemorySetting.button.reset': '重置',
  'pages.agentMemorySetting.button.save': '保存',
  'pages.agentMemorySetting.save.success': '保存成功',
  'pages.agentMemorySetting.save.error': '保存失败',
  'pages.agentMemorySetting.save.missingId': '缺少 agent id，无法保存',
  'pages.agentMemorySetting.save.loadFailed': '无法加载智能体信息',
  'pages.agentMemorySetting.unavailable': '当前系统未开启记忆功能，请联系管理员在系统配置中启用。',

  // AgentSetting 页面相关文本
  'pages.agentSetting.title': '配置角色',
  'pages.agentSetting.back': '返回',
  'pages.agentSetting.roleTemplate.title': '角色模板',
  'pages.agentSetting.roleTemplate.label': '模板',
  'pages.agentSetting.template.taiwanGirlfriend': '台湾女友',
  'pages.agentSetting.template.potato': '土豆子',
  'pages.agentSetting.template.englishTutor': 'English Tutor',
  'pages.agentSetting.template.curiousBoy': '好奇小男孩',
  'pages.agentSetting.template.puppyLeader': '汪汪队长',
  'pages.agentSetting.basicConfig.title': '基础配置',
  'pages.agentSetting.assistantName.label': '助手昵称',
  'pages.agentSetting.assistantName.placeholder': '请输入助手昵称',
  'pages.agentSetting.assistantName.required': '请输入助手昵称',
  'pages.agentSetting.minorBand.label': '未成年分龄',
  'pages.agentSetting.minorBand.tip':
    '与设备分龄取更严。青少年：约 12–17 岁，默认可聊约 120 分钟；儿童：约 12 岁以下，内容更严，默认约 60 分钟休息。关闭表示智能体侧不限制。',
  'pages.agentSetting.minorBand.off': '关闭',
  'pages.agentSetting.minorBand.teen': '青少年',
  'pages.agentSetting.minorBand.child': '儿童',
  'pages.agentSetting.minorBand.teenDesc':
    '约 12–17 岁：守未成年人底线，可适度疏导社交；默认约聊 120 分钟后休息 30 分钟',
  'pages.agentSetting.minorBand.childDesc':
    '约 12 岁以下：内容/隐私更严、语气更幼龄；默认约聊 60 分钟后休息 30 分钟',
  'pages.agentSetting.minorBand.compareTip':
    '儿童比青少年更严（词表更宽、休息周期更短）。两边都开时取更严档。',
  'pages.agentSetting.minorBand.saveWarn': '角色已保存，但未成年分龄未写入',
  'pages.agentSetting.dialogLanguage.label': '对话语言',
  'pages.agentSetting.dialogLanguage.placeholder': '选择对话语言',
  'pages.agentSetting.voiceType.label': '角色音色',
  'pages.agentSetting.voiceType.placeholder': '选择角色音色',
  'pages.agentSetting.voiceType.preview': '试听',
  'pages.agentSetting.voiceType.previewMissing': '该音色暂无试听音频',
  'pages.agentSetting.voiceType.previewFail': '试听播放失败',
  'pages.agentSetting.voiceType.previewGenerateFail': '生成失败，请稍后重试',
  'pages.agentSetting.voiceType.previewGenerating': '正在生成试听音频…',
  'pages.agentSetting.voiceType.groupClone': '我的克隆音色',
  'pages.agentSetting.voiceType.groupPreset': '系统预设音色',
  'pages.agentSetting.voiceType.filterAll': '全部',
  'pages.agentSetting.voiceType.filterClone': '我的克隆',
  'pages.agentSetting.voiceType.filterPreset': '系统预设',
  'pages.agentSetting.voiceType.cloneTag': '克隆',
  'pages.agentSetting.voiceType.cloneTagHint': '带「克隆」标签的为您自建音色；也可通过上方筛选仅查看克隆音色',
  'pages.agentSetting.voiceType.noCloneHint': '当前语言下暂无克隆音色，可前往',
  'pages.agentSetting.voiceType.noCloneLink': '音色克隆',
  'pages.agentSetting.voiceType.noCloneHintSuffix': '页创建',
  'pages.agentSetting.roleDescription.title': '角色介绍',
  'pages.agentSetting.roleDescription.label': '角色介绍',
  'pages.agentSetting.roleDescription.placeholder': '请输入角色介绍',
  'pages.agentSetting.roleDescription.required': '请输入角色介绍',
  'pages.agentSetting.roleDescription.custom': '自定义',
  'pages.agentSetting.roleDescription.presetLabel': '预设介绍',
  'pages.agentSetting.roleDescription.presetHint': '关闭自定义后使用当前对话语言对应的模板预设',
  'pages.agentSetting.roleDescription.restorePreset': '恢复为预设',
  'pages.agentSetting.roleDescription.restorePresetDone': '已恢复为预设，可在此基础上修改',
  'pages.agentSetting.roleDescription.restoredCustom': '已恢复上次自定义内容',
  'pages.agentSetting.roleDescription.selectTemplateFirst': '请先选择角色模板后再关闭自定义以使用预设介绍',
  'pages.agentSetting.languageModel.title': '语言模型',
  'pages.agentSetting.languageModel.label': '语言模型',
  'pages.agentSetting.languageModel.placeholder': '选择语言模型',
  'pages.agentSetting.languageModel.tip': '改变模型后，建议清空记忆体，以免影响聊天体验。',
  'pages.agentSetting.thinkingEnabled.label': '开启思考模式',
  'pages.agentSetting.thinkingEnabled.tip': '开启后回复可能更慢；语音播报仍会过滤思考过程。',
  'pages.agentSetting.advancedSettings.expand': '展开高级设置',
  'pages.agentSetting.advancedSettings.collapse': '收起高级设置',
  'pages.agentSetting.recognitionSpeed.label': '语音识别速度',
  'pages.agentSetting.recognitionSpeed.placeholder': '选择识别速度',
  'pages.agentSetting.intentMergeEnabled.label': '智能拒答 L3（dialog.no_reply）',
  'pages.agentSetting.intentMergeEnabled.tooltip':
    '覆盖系统「并入主对话 L3」：跟随全局 / 强制开启 / 强制关闭。L3=主对话里模型可声明不回；与全局 L1/L2/L2.5 硬门配合。儿童陪伴等怕误杀的角色建议强制关闭。',
  'pages.agentSetting.intentMergeEnabled.inherit': '跟随全局',
  'pages.agentSetting.intentMergeEnabled.on': '强制开启',
  'pages.agentSetting.intentMergeEnabled.off': '强制关闭',
  'pages.agentSetting.speechSpeed.label': '角色语速',
  'pages.agentSetting.speechSpeed.placeholder': '选择语速',
  'pages.agentSetting.pitchValue.label': '角色音量',
  'pages.agentSetting.button.reset': '重置',
  'pages.agentSetting.button.save': '保存',
  'pages.agentSetting.save.success': '保存成功',
  'pages.agentSetting.save.error': '保存失败',
  'pages.agentSetting.save.missingId': '缺少 agent id，无法保存',
  'pages.agentSetting.load.tts.error': '加载TTS音色失败',
  'pages.agentSetting.speed.slow': '慢速',
  'pages.agentSetting.speed.normal': '正常',
  'pages.agentSetting.speed.fast': '快速',
  'pages.agentSetting.speed.patient': '耐心',
  'pages.agentSetting.language.chinese': '普通话',
  'pages.agentSetting.language.english': '英语',
  'pages.agentSetting.language.cloned': '克隆音色',
  'pages.agentSetting.voiceClone.optionLabel': '【克隆】{name}',
  'pages.voiceClone.fieldLanguage': '语言',
  'pages.voiceClone.fieldLanguageHint':
    '用于在「智能体信息维护」中与当前 TTS 预设音色按相同语言分类展示；旧数据无该字段时列表显示为「—」，编辑保存前可重新克隆补充。',
  'pages.voiceClone.fieldLanguagePlaceholder': '选择该克隆音色所属语言',
  'pages.voiceClone.fieldRefText': '参考文本',
  'pages.voiceClone.fieldRefTextHint':
    '请填写这段参考音频里实际朗读的文字内容（与 CosyVoice 要求一致，需与录音逐字对应）',
  'pages.voiceClone.fieldRefTextPlaceholder': '例如：在一无所知中，梦里的一天结束了，一个新的轮回便会开始。',
  'pages.voiceClone.fieldAlias': '名称',
  'pages.voiceClone.fieldProvider': 'TTS 提供商',
  'pages.voiceClone.fieldProviderPlaceholder': '请选择声音克隆提供商',
  'pages.voiceClone.fieldProviderHint':
    '请选择已接入声音克隆的 TTS；克隆音色需与智能体使用同一提供商类型才能合成',
  'pages.voiceClone.noCloneProvider': '暂无已实现克隆的 TTS，请先在系统配置中添加并启用',
  'pages.voiceClone.colCloneId': '克隆 ID',
  'pages.voiceClone.colSampleId': '样本 ID',
  'pages.voiceClone.colSampleAlias': '样本名称',
  'pages.voiceClone.colSampleText': '样本参考文本',
    'pages.voiceClone.colVoiceUri': '音色 URI',
    'pages.voiceClone.playSample': '试听样本',
    'pages.voiceClone.playSampleStop': '停止',
    'pages.voiceClone.playSampleFailed': '样本音频播放失败',
    'pages.voiceClone.playSampleMissing': '无关联样本，无法试听',
    'pages.voiceClone.playClone': '试听音色',
    'pages.voiceClone.playCloneStop': '停止',
    'pages.voiceClone.playCloneGenerating': '生成中…',
    'pages.voiceClone.playCloneFailed': '克隆音色试听失败',
    'pages.voiceClone.playCloneMissing': '缺少音色信息，无法试听',
    'pages.voiceClone.colCreatedAt': '创建时间',
  'pages.voiceClone.colUpdatedAt': '更新时间',
  'pages.voiceClone.addTitle': '添加声音克隆',
  'pages.voiceClone.sampleUploaded': '声音样本已上传',
  'pages.voiceClone.uploadSampleFailed': '上传样本失败',
  'pages.voiceClone.step1Button': '上传样本（第 1 步）',
  'pages.voiceClone.backToStep1': '返回修改样本',
  'pages.voiceClone.cloneSuccess': '克隆已保存',
  'pages.voiceClone.cloneFailed': '克隆训练失败',
  'pages.voiceClone.step2Button': '发起克隆训练（第 2 步）',
  'pages.voiceClone.step1Title': '上传声音样本',
  'pages.voiceClone.step1Desc':
    '填写名称、参考文本、提供商；录制或上传 WAV（≤5MB）后在确认面板截取 8～20 秒并确认，再上传样本',
  'pages.voiceClone.step2Title': '云端克隆训练',
  'pages.voiceClone.step2Desc': '调用提供商接口训练，可能耗时较久',
  'pages.voiceClone.step2AlertTitle': '样本已在服务器就绪',
  'pages.voiceClone.step2AlertDesc':
    '点击下方「发起克隆训练」将调用硅基流动等服务完成音色克隆；请勿关闭页面直至完成。',
  'pages.voiceClone.selectWavTip': '请选择一个 wav 文件',
  'pages.voiceClone.tabClones': '克隆列表',
  'pages.voiceClone.cloneList': '音色克隆列表',
  'pages.voiceClone.tabOrders': '次数包订单',
  'pages.agentSetting.language.spanish': '西班牙语',
  'pages.agentSetting.language.french': '法语',
  'pages.agentSetting.language.german': '德语',
  'pages.agentSetting.language.japanese': '日语',
  'pages.agentSetting.language.korean': '韩语',
  'pages.agentSetting.language.portuguese': '葡萄牙语',
  'pages.agentSetting.language.arabic': '阿拉伯语',
  'pages.agentSetting.language.russian': '俄语',
  'pages.agentSetting.language.italian': '意大利语',
  'pages.agentSetting.language.turkish': '土耳其语',
  'pages.agentSetting.language.polish': '波兰语',
  'pages.agentSetting.language.catalan': '加泰罗尼亚语',
  'pages.agentSetting.mcp.modal.title': 'MCP接入点',
  'pages.agentSetting.mcp.modal.statusLabel': '接入点状态',
  'pages.agentSetting.mcp.modal.online': '在线',
  'pages.agentSetting.mcp.modal.disconnected': '未连接',
  'pages.agentSetting.mcp.modal.unknown': '未连接',
  'pages.agentSetting.mcp.modal.refresh': '刷新',
  'pages.agentSetting.mcp.modal.enabledServices': '启用的服务',
  'pages.agentSetting.mcp.modal.endpointLabel': '接入点地址',
  'pages.agentSetting.mcp.modal.endpointDesc': '以下是智能体的MCP接入点地址。',
  'pages.agentSetting.mcp.modal.docLink': '查看接入点使用文档',
  'pages.agentSetting.mcp.modal.noEndpoint': '无可用接入点',
  'pages.agentSetting.mcp.modal.hide': '隐藏',
  'pages.agentSetting.mcp.modal.show': '显示',
  'pages.agentSetting.mcp.modal.copied': '已复制',
  'pages.agentSetting.mcp.modal.copy': '复制',
  'pages.agentSetting.mcp.title': 'MCP设置',
  'pages.agentSetting.mcp.officialServices': '官方服务',
  'pages.agentSetting.mcp.officialServices.placeholder': '选择官方服务',
  'pages.agentSetting.mcp.services.weather': '天气',
  'pages.agentSetting.mcp.services.joke': '笑话',
  'pages.agentSetting.mcp.services.music': '音乐',
  'pages.agentSetting.mcp.services.news': '新闻',
  'pages.agentSetting.mcp.customService': '自定义服务',
  'pages.agentSetting.knowledgeBase.label': '知识库',
  'pages.agentSetting.knowledgeBase.none': '无',
  'pages.agentSetting.knowledgeBase.placeholder': '请选择知识库',
  'pages.agentSetting.knowledgeBase.config': '配置',
  'pages.agentSetting.mcp.error.missingId': '缺少 agent id，无法获取接入点',
  'pages.agentSetting.mcp.error.noEndpoint': '无法从服务端获取接入点',
  'pages.agentSetting.mcp.error.fetchFailed': '获取接入点失败',
  'pages.agentSetting.mcp.button.getEndpoint': '获取 MCP 接入点',

  // Memory settings
  'pages.agentSetting.memory.title': '记忆设置',
  'pages.agentSetting.memory.type.label': '记忆类型',
  'pages.agentSetting.memory.type.none': '无记忆',
  'pages.agentSetting.memory.type.shortTerm': '短期记忆',
  'pages.agentSetting.memory.type.longTerm': '长期记忆',
  'pages.agentSetting.memory.current.label.short': '当前记忆',
  'pages.agentSetting.memory.current.label.long': '长期记忆',
  'pages.agentSetting.memory.current.help': '每次对话后重新生成',
  'pages.agentSetting.memory.longTerm.help': '长期记忆会在对话结束后自动生成摘要锚点，并在后续相关问题中按需检索。关闭后不会清空已有记忆，只会停止写入与检索。',
  'pages.agentSetting.memory.longTerm.clear.tip': '长期记忆已标记为清除，请点击保存以应用生效',
  'pages.agentSetting.memory.longTerm.content.placeholder': '暂无 long_term_memory 内容，对话后会自动生成，也可点击编辑手动补充',
  'pages.agentSetting.memory.longTerm.content.editPlaceholder': '请输入 long_term_memory 内容，建议保持 JSON 格式',
  'pages.agentSetting.memory.clear': '清除记忆',
  'pages.agentSetting.memory.clear.tip': '记忆已标记为清除，请点击保存以应用生效',
  'pages.agentSetting.memory.content.label': '记忆内容',
  'pages.agentSetting.memory.content.placeholder': '获取当前智能体最新短期记忆内容',
  'pages.agentSetting.memory.content.editPlaceholder': '请输入记忆内容',
  'pages.agentSetting.memory.edit': '编辑记忆',
  'pages.agentSetting.memory.edit.success': '记忆已更新，请在保存后生效',
  'pages.agentSetting.memory.edit.save': '保存修改',
  'pages.agentSetting.memory.edit.cancel': '取消',
  'pages.agentSetting.memory.longTerm.profile.label': '用户画像（长期记忆）',
  'pages.agentSetting.memory.longTerm.invalidJson': '当前内容不是合法 JSON，已切换为原始文本编辑。',
  'pages.agentSetting.memory.longTerm.emptyProfile':
    '暂无结构化画像。对话并开启采集后会自动填充，也可点击「编辑记忆」手动维护。',
  'pages.agentSetting.memory.longTerm.section.basic': '基本信息',
  'pages.agentSetting.memory.longTerm.section.prefs': '偏好与习惯',
  'pages.agentSetting.memory.longTerm.section.relations': '关系与社交',
  'pages.agentSetting.memory.longTerm.section.lifestyle': '个性与生活',
  'pages.agentSetting.memory.longTerm.section.meta': '补充说明与记录信息',
  'pages.agentSetting.memory.longTerm.section.extra': '自由补充',
  'pages.agentSetting.memory.longTerm.backToForm': '返回表单编辑',
  'pages.agentSetting.memory.longTerm.switchJson': '切换到 JSON 源码编辑',
  'pages.agentSetting.memory.longTerm.mode.form': '表单编辑',
  'pages.agentSetting.memory.longTerm.mode.json': 'JSON 源码',
  'pages.agentSetting.memory.longTerm.jsonEditor.hint': '直接编辑 JSON，切换回表单时会自动解析并填充各字段（需为合法对象格式）。',
  'pages.agentSetting.memory.longTerm.formHint':
    '修改会实时反映到 JSON 草稿；保存智能体后生效。创建时间、版本等元数据在合法 JSON 下会自动保留。',
  'pages.agentSetting.memory.longTerm.field.nickname': '称呼',
  'pages.agentSetting.memory.longTerm.field.age': '年龄 / 年龄段',
  'pages.agentSetting.memory.longTerm.field.gender': '性别',
  'pages.agentSetting.memory.longTerm.field.occupation': '职业',
  'pages.agentSetting.memory.longTerm.field.location': '所在地',
  'pages.agentSetting.memory.longTerm.field.birthday': '生日',
  'pages.agentSetting.memory.longTerm.field.education': '学历',
  'pages.agentSetting.memory.longTerm.field.mbti': 'MBTI',
  'pages.agentSetting.memory.longTerm.field.zodiac': '星座',
  'pages.agentSetting.memory.longTerm.field.timezone': '时区',
  'pages.agentSetting.memory.longTerm.field.communication_style': '沟通风格偏好',
  'pages.agentSetting.memory.longTerm.field.personality': '性格特点',
  'pages.agentSetting.memory.longTerm.field.personality_short': '性格',
  'pages.agentSetting.memory.longTerm.field.pets': '宠物',
  'pages.agentSetting.memory.longTerm.field.pets_short': '宠物',
  'pages.agentSetting.memory.longTerm.field.goals': '目标 / 愿望',
  'pages.agentSetting.memory.longTerm.field.goals_short': '目标',
  'pages.agentSetting.memory.longTerm.field.health_notes': '健康 / 过敏注意',
  'pages.agentSetting.memory.longTerm.field.health_notes_short': '健康注意',
  'pages.agentSetting.memory.longTerm.field.important_dates': '重要日期',
  'pages.agentSetting.memory.longTerm.field.important_dates_short': '重要日期',
  'pages.agentSetting.memory.longTerm.field.hobbies_short': '爱好',
  'pages.agentSetting.memory.longTerm.field.hobbies': '爱好（可多值，回车或逗号分隔）',
  'pages.agentSetting.memory.longTerm.field.preferences': '偏好',
  'pages.agentSetting.memory.longTerm.field.dislikes': '不喜欢 / 规避',
  'pages.agentSetting.memory.longTerm.field.family': '家庭成员',
  'pages.agentSetting.memory.longTerm.field.relationships': '重要关系',
  'pages.agentSetting.memory.longTerm.field.extra_memory': '其他长期信息（分号或换行均可）',
  'pages.agentSetting.memory.longTerm.field.is_locked': '锁定画像（只读，服务端采集不再改）',
  'pages.agentSetting.memory.longTerm.field.created_at': '创建时间',
  'pages.agentSetting.memory.longTerm.field.last_updated': '最后更新',
  'pages.agentSetting.memory.longTerm.field.version': '版本号',
  'pages.agentSetting.memory.longTerm.field.is_locked_short': '已锁定（只读）',
  'pages.agentSetting.memory.longTerm.placeholder.nickname': '例如：小明',
  'pages.agentSetting.memory.longTerm.placeholder.age': '例如：25、大学生',
  'pages.agentSetting.memory.longTerm.placeholder.tags': '输入后回车添加',
  'pages.agentSetting.memory.longTerm.placeholder.extra_memory': '例如：对猫毛过敏；周末通常在家',
  'pages.agentSetting.memory.longTerm.bool.yes': '是',
  'pages.agentSetting.memory.longTerm.bool.no': '否',
  'pages.agentSetting.memory.longTerm.dash': '—',

  // DeviceManagement 页面相关文本
  'pages.devices.title': '管理设备',
  'pages.devices.breadcrumb.agents': '智能体',
  'pages.devices.breadcrumb.devices': '管理设备',
  'pages.devices.button.addDevice': '添加设备',
  'pages.devices.warning.noAgentId': '未指定 agentId，无法获取设备列表',
  'pages.devices.device.unnamed': '未命名设备',
  'pages.devices.device.macAddress': 'Mac地址',
  'pages.devices.device.lastActive': '最近对话',
  'pages.devices.device.firmwareVersion': '固件版本',
  'pages.devices.device.otaUpgrade': 'OTA升级',
  'pages.devices.guard.entry': '未成年守护',
  'pages.devices.guard.title': '未成年守护 · {name}',
  'pages.devices.guard.hint':
    '此处设置仅对本设备生效；与智能体分龄取更严一档。儿童比青少年更严（内容红线更宽、默认约 60 分钟休息；青少年默认可聊约 120 分钟）。防沉迷「本周期」不是自然日：累计有效对话满额后休息，休息结束后才清零；过零点不会自动清空本周期。「当日」才是自然日累计（日限可选）。管理员可在后台调整全局策略与临时豁免。',
  'pages.devices.guard.effectiveBand': '当前生效分龄',
  'pages.devices.guard.agentBand': '智能体分龄',
  'pages.devices.guard.deviceBand': '设备分龄',
  'pages.devices.guard.restStatus': '防沉迷状态',
  'pages.devices.guard.resting': '休息中，剩余 {duration}',
  'pages.devices.guard.dailyExhausted': '今日已满，剩余 {duration}',
  'pages.devices.guard.nearRest': '临近休息',
  'pages.devices.guard.normal': '正常',
  'pages.devices.guard.cycleUsage': '本周期有效对话',
  'pages.devices.guard.cycleUsageTip':
    '「本周期」= 休息周期累计有效对话，不是今天。默认约聊满 2 小时后休息约 30 分钟；过零点不会自动清零，休息结束后才重新从 0 计。',
  'pages.devices.guard.dailyUsage': '当日有效对话',
  'pages.devices.guard.dailyUsageTip':
    '「当日」按配置时区（默认北京时间）自然日累计。仅启用日限时作为当天总量硬顶；与「本周期」相互独立。',
  'pages.devices.guard.usageRuleTip':
    '用量说明：「本周期」不是自然日，过零点不清零；休息结束后才开新周期。「当日」才是自然日累计（日限可选）。',
  'pages.devices.guard.dailyUnlimited': '未启用日限',
  'pages.devices.guard.grant': '临时放行',
  'pages.devices.guard.grantActive': '生效中',
  'pages.devices.guard.grantNone': '无',
  'pages.devices.guard.deviceBandEdit': '设置本设备分龄',
  'pages.devices.guard.band.off': '关闭',
  'pages.devices.guard.band.teen': '青少年',
  'pages.devices.guard.band.child': '儿童',
  'pages.devices.guard.band.offDesc': '不启用本设备分龄内容约束',
  'pages.devices.guard.band.teenDesc':
    '约 12–17 岁：守未成年人底线，可适度疏导社交；默认约聊 120 分钟后休息 30 分钟',
  'pages.devices.guard.band.childDesc':
    '约 12 岁以下：内容/隐私更严、语气更幼龄；默认约聊 60 分钟后休息 30 分钟',
  'pages.devices.guard.band.compareTip':
    '怎么选：低龄选「儿童」，初高中可选「青少年」。儿童更严；与智能体档同时开启时取更严一档。',
  'pages.devices.guard.save': '保存分龄',
  'pages.devices.guard.saveSuccess': '分龄已保存',
  'pages.devices.guard.saveFail': '保存失败',
  'pages.devices.guard.loadFail': '加载守护状态失败',
  'pages.devices.device.timezone': '设备时区',
  'pages.devices.device.timezone.hint': '设备屏显、历史对话与日记时间均按此时区展示',
  'pages.devices.device.noData': '暂无',
  'pages.devices.copy.success': 'MAC地址已复制',
  'pages.devices.unbind.title': '确认解绑设备',
  'pages.devices.unbind.content': '设备解绑后不可恢复，如需再次使用需重新绑定。是否确认解绑？',
  'pages.devices.unbind.confirm': '确认解绑',
  'pages.devices.unbind.cancel': '取消',
  'pages.devices.unbind.success': '设备已解绑',
  'pages.devices.unbind.error': '解绑失败',
  'pages.devices.ota.enabled': 'OTA升级已开启',
  'pages.devices.ota.disabled': 'OTA升级已关闭',
  'pages.devices.simUsage.button': '用量查询',
  'pages.devices.simRecharge.button': '流量套餐充值',

  // Web 控制台 — 流量卡充值（SimRecharge）
  'pages.simRecharge.refundCol': '退款',
  'pages.simRecharge.refundBtn': '申请原路退款',
  'pages.simRecharge.refundBtnRetry': '再次发起退款',
  'pages.simRecharge.refundTagSuccess': '已原路退款',
  'pages.simRecharge.refundTagProcessing': '退款处理中',
  'pages.simRecharge.refundProcessingTip': '微信正在处理退款，若长时间未到账可再次点击尝试同步',
  'pages.simRecharge.refundUnavailable': '—',
  'pages.simRecharge.refundNoWechat': '无微信支付单',
  'pages.simRecharge.refundConfirmTitle': '确认申请微信原路退款？',
  'pages.simRecharge.refundConfirmContent':
    '订单 {no} 将向微信支付申请按支付金额全额退回，到账时间以微信为准。是否继续？',
  'pages.simRecharge.refundConfirmOk': '确认退款',
  'pages.simRecharge.refundConfirmCancel': '取消',
  'pages.simRecharge.refundOk': '已提交退款申请',
  'pages.simRecharge.refundFail': '退款失败',
  'pages.simRecharge.cancelFail': '取消订单失败',
  'pages.simRecharge.colActions': '操作',
  'pages.simRecharge.viewDetail': '详情',
  'pages.simRecharge.orderDetailTitle': '订单详情',
  'pages.simRecharge.detailLoadFail': '加载订单详情失败',
  'pages.simRecharge.detailSecOrder': '订单与支付',
  'pages.simRecharge.detailSecDevice': '设备',
  'pages.simRecharge.detailSecAgent': '智能体',
  'pages.simRecharge.detailSecSimCard': '物理网卡（下单快照）',
  'pages.simRecharge.detailSecPackage': '套餐',
  'pages.simRecharge.d.orderNo': '订单号',
  'pages.simRecharge.d.status': '状态',
  'pages.simRecharge.d.amount': '金额(元)',
  'pages.simRecharge.d.payChannel': '支付渠道',
  'pages.simRecharge.d.wechatTradeNo': '微信交易号',
  'pages.simRecharge.d.paidAt': '支付时间',
  'pages.simRecharge.d.createdAt': '创建时间',
  'pages.simRecharge.d.failedReason': '失败原因',
  'pages.simRecharge.d.rechargeError': '物联充值错误',
  'pages.simRecharge.d.refundStatus': '退款状态',
  'pages.simRecharge.d.devId': '设备 ID',
  'pages.simRecharge.d.devName': '设备名称',
  'pages.simRecharge.d.devMac': '设备 MAC',
  'pages.simRecharge.d.devIccid': '设备当前 ICCID',
  'pages.simRecharge.d.agentId': '智能体 ID',
  'pages.simRecharge.d.agentName': '智能体名称',
  'pages.simRecharge.d.iccid': 'ICCID',
  'pages.simRecharge.d.iotSCode': '物联卡号(iotSCode)',
  'pages.simRecharge.d.providerCode': '卡归属提供商',
  'pages.simRecharge.d.platformOrder': '平台订单号',
  'pages.simRecharge.d.pkgId': '套餐 ID',
  'pages.simRecharge.d.pkgName': '套餐名称',
  'pages.simRecharge.d.pkgPlatCode': '平台套餐编码',
  'pages.simRecharge.d.pkgPrice': '下单售价(元)',
  'pages.simRecharge.d.pkgProvName': '套餐提供商',
  'pages.simRecharge.d.pkgProvCode': '提供商代码',

  'pages.devices.simUsage.title': '套餐内 GPRS 流量（实时）',
  'pages.devices.simUsage.errorUnknown': '查询失败',
  'pages.devices.simUsage.sectionUsage': '平台返回用量',
  'pages.devices.simUsage.field.provider_name': '物联平台',
  'pages.devices.simUsage.field.provider_code': '平台代码',
  'pages.devices.simUsage.field.iccid': 'ICCID',
  'pages.devices.simUsage.field.platform_message': '平台说明',
  'pages.devices.simUsage.field.number': '卡号',
  'pages.devices.simUsage.field.total': '套餐总量(MB)',
  'pages.devices.simUsage.field.left': '剩余(MB)',
  'pages.devices.simUsage.field.used': '已用(MB)',
  'pages.devices.simUsage.field.prodname': '套餐名称',
  'pages.devices.simUsage.field.prodid': '套餐ID',
  'pages.devices.simUsage.field.prodinstid': '产品实例ID',

  'pages.devices.simCard.button': '卡信息查询',
  'pages.devices.simCard.title': '物联卡卡信息',
  'pages.devices.simCard.errorUnknown': '查询失败',
  'pages.devices.simCard.sectionCard': '卡详情',
  'pages.devices.simCard.sectionPackages': '可订购套餐（价格已隐藏）',
  'pages.devices.simCard.field.provider_name': '物联平台',
  'pages.devices.simCard.field.provider_code': '平台代码',
  'pages.devices.simCard.field.iccid': 'ICCID',
  'pages.devices.simCard.field.platform_message': '平台说明',
  'pages.devices.simCard.field.iotSCode': '运营商卡号',
  'pages.devices.simCard.field.iotsCode': '运营商卡号',
  'pages.devices.simCard.field.iotscode': '运营商卡号',
  'pages.devices.simCard.field.IMSI': 'IMSI',
  'pages.devices.simCard.field.CSDate': '测试截止日期',
  'pages.devices.simCard.field.CMDate': '沉默截止日期',
  'pages.devices.simCard.field.FWDate': '服务到期时间',
  'pages.devices.simCard.field.JHDate': '激活时间',
  'pages.devices.simCard.field.Sp': '运营商',
  'pages.devices.simCard.field.sp': '运营商',
  'pages.devices.simCard.field.cardform': '卡形态',
  'pages.devices.simCard.field.cardcl': '生命周期',
  'pages.devices.simCard.field.cstate': '卡状态',
  'pages.devices.simCard.field.usedFlow': '已使用流量(M)',
  'pages.devices.simCard.field.surplusFlow': '剩余流量(M)',
  'pages.devices.simCard.field.monthTotalFlow': '本月流量总量(M)',
  'pages.devices.simCard.field.outRepositoryTime': '出库时间',
  'pages.devices.simCard.field.customerRemark': '客户备注',
  'pages.devices.simCard.field.gprsState': 'GPRS 状态',
  'pages.devices.simCard.field.cardState': '卡片业务状态（平台字段）',
  'pages.devices.simCard.field.packageList': '可订购套餐',
  'pages.devices.simCard.field.packageCode': '套餐编码',
  'pages.devices.simCard.field.packageName': '套餐名称',

  // HistoryDialogs 页面相关文本
  'pages.historyDialogs.title': '历史对话',
  'pages.historyDialogs.breadcrumb.agents': '智能体',
  'pages.historyDialogs.breadcrumb.historyDialogs': '历史对话',
  'pages.historyDialogs.empty.title': '没有选中对话',
  'pages.historyDialogs.empty.description': '请选择一个对话',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': '对话详情',
  'pages.historyDialogs.selectConversation': '请选择一个对话',
  'pages.historyDialogs.delete.title': '删除对话',
  'pages.historyDialogs.delete.content': '删除后无法恢复，请确认操作。',
  'pages.historyDialogs.delete.confirm': '确认删除',
  'pages.historyDialogs.delete.cancel': '取消',
  'pages.historyDialogs.batchDelete.selectAll': '全选',
  'pages.historyDialogs.batchDelete.button': '批量删除',
  'pages.historyDialogs.batchDelete.title': '批量删除对话',
  'pages.historyDialogs.batchDelete.content': '确定要删除选中的 {count} 条对话记录吗？此操作不可恢复。',
  'pages.historyDialogs.batchDelete.success': '已删除 {count} 条对话',
  'pages.historyDialogs.batchDelete.fail': '批量删除失败',
  'pages.historyDialogs.message.delete.confirm': '确定要删除该消息吗？删除后不可恢复。',
  'pages.historyDialogs.detail.title': '对话详情',
  'pages.historyDialogs.list.noTitle': '未命名会话',

  'pages.historyDialogs.agent.label': '智能体:',
  'pages.historyDialogs.user.label': '用户:',
  'pages.historyDialogs.loading': '加载中...',
  'pages.historyDialogs.error.loadFailed': '加载对话列表失败',
  'pages.historyDialogs.error.deleteFailed': '删除会话失败',
  'pages.historyDialogs.success.deleteSuccess': '成功删除对话',
  'pages.historyDialogs.noAudioHint':
    '本会话暂无可回听的录音，可能尚未保存或已超过可回听时间。',
  'pages.historyDialogs.audioRetainHint':
    '录音默认仅可回听最近 {hours} 小时内的内容，超时后不再提供播放。',

  // MessageList 页面相关文本
  'pages.messageList.empty': '暂无消息',
  'pages.messageList.user': 'User',
  'pages.messageList.ai': 'AI',
  'pages.messageList.playAudio': '播放录音',
  'pages.messageList.audioPlayFailed': '音频不存在或已过期',
  'pages.messageList.toolCall': '调用工具: {name}',
  'pages.messageList.toolArgs': '参数',
  'pages.messageList.toolResult': '返回结果',
  'pages.messageList.copied': '已复制',
  'pages.messageList.copyFailed': '复制失败',

  // Settings 页面相关文本
  'pages.settings.basicInfo.title': '基本信息',
  'pages.settings.avatar.label': '头像：',
  'pages.settings.avatar.change': '更换头像',
  'pages.settings.avatar.updateSuccess': '头像已更新',
  'pages.settings.avatar.updateFailed': '头像更新失败',
  'pages.settings.registerTime.label': '注册时间：',
  'pages.settings.email.label': '邮箱：',
  'pages.settings.email.unbind': '未绑定',
  'pages.settings.email.bind': '绑定邮箱',
  'pages.settings.email.change': '修改绑定邮箱',
  'pages.settings.email.modal.title': '绑定邮箱',
  'pages.settings.email.modal.changeTitle': '修改绑定邮箱',
  'pages.settings.email.form.label': '邮箱',
  'pages.settings.email.form.required': '请输入邮箱',
  'pages.settings.email.form.invalid': '邮箱格式不正确',
  'pages.settings.email.bindSuccess': '邮箱绑定成功',
  'pages.settings.email.bindFailed': '绑定失败',
  'pages.settings.changePassword.title': '修改密码',
  'pages.settings.changePassword.button': '修改密码',
  'pages.settings.changePassword.modal.title': '修改密码',
  'pages.settings.changePassword.oldPassword.label': '旧密码',
  'pages.settings.changePassword.oldPassword.required': '请输入旧密码',
  'pages.settings.changePassword.newPassword.label': '新密码',
  'pages.settings.changePassword.newPassword.required': '请输入新密码',
  'pages.settings.changePassword.newPassword.min': '新密码长度至少6位',
  'pages.settings.changePassword.confirmPassword.label': '确认新密码',
  'pages.settings.changePassword.confirmPassword.required': '请确认新密码',
  'pages.settings.changePassword.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.settings.changePassword.success': '密码修改成功',
  'pages.settings.changePassword.failed': '密码修改失败',
  'pages.settings.deleteAccount.title': '删除账号',
  'pages.settings.deleteAccount.button': '删除账号',
  'pages.settings.deleteAccount.confirm.title': '确认删除账号？',
  'pages.settings.deleteAccount.confirm.content': '此操作不可恢复，确定要删除账号吗？',
  'pages.settings.deleteAccount.confirm.ok': '删除',
  'pages.settings.deleteAccount.confirm.cancel': '取消',
  'pages.settings.deleteAccount.success': '账号已删除',
  'pages.settings.deleteAccount.failed': '删除失败',
  'pages.settings.profile.fetchFailed': '获取用户信息失败',
  'pages.settings.form.submit': '提交',
  'pages.settings.password.title': '密码设置',
  'pages.settings.basicInfo.username': '用户名',
  'pages.settings.basicInfo.nickname': '昵称',
  'pages.settings.basicInfo.avatar': '头像',
  'pages.settings.basicInfo.editNickname': '编辑昵称',
  'pages.settings.basicInfo.editNicknameTitle': '修改昵称',
  'pages.settings.basicInfo.newNicknameLabel': '新昵称',
  'pages.settings.basicInfo.nicknameChangeSuccess': '昵称修改成功',
  'pages.settings.basicInfo.openId': 'OpenID：',
  'pages.settings.submit': '保存',
  'pages.settings.deleteAccount.confirmTitle': '删除账号确认',
  'pages.settings.deleteAccount.confirmContent': '删除账号后，您的所有数据将被永久删除且无法恢复，且您将无法再次使用该账号登录。请谨慎操作！',
  'pages.settings.deleteAccount.cancel': '取消',
  'pages.settings.deleteAccount.confirm': '确认删除',

  // Admin Dashboard
  'pages.admin.dashboard.userCount': '用户数量',
  'pages.admin.dashboard.deviceCount': '设备数量',
  'pages.admin.dashboard.agentCount': '智能体数量',
  'pages.admin.dashboard.onlineUsers': '在线用户数',
  'pages.admin.dashboard.sessionDevices': '对话用户数',
  'pages.admin.dashboard.websocketConnections': 'WebSocket 连接数',
  'pages.admin.dashboard.mqttConnections': 'MQTT 连接数',
  'pages.admin.dashboard.mqttUdpSessions': 'MQTT UDP 会话数',
  'pages.admin.dashboard.devicesInDialogue': '对话设备数',
  'pages.admin.dashboard.poolMcp': 'MCP 资源池',
  'pages.admin.dashboard.poolAsr': 'ASR 资源池',
  'pages.admin.dashboard.poolTts': 'TTS 资源池',
  'pages.admin.dashboard.poolUsageHint': '使用中/上限',
  'pages.admin.dashboard.instanceBadge': '实例 {instanceId} · {role}',
  'pages.admin.dashboard.localInstanceHint': '本实例',
  'pages.admin.dashboard.redisClusterHint': 'Redis 集群',
  'pages.admin.dashboard.memoryUsage': '内存使用率',
  'pages.admin.dashboard.cpuUsage': 'CPU使用率',
  'pages.admin.dashboard.fetchError': '获取数据失败',
  'pages.admin.dashboard.networkError': '网络错误',
  'pages.admin.dashboard.property': '属性',
  'pages.admin.dashboard.value': '值',
  'pages.admin.dashboard.systemMemory': '内存',
  'pages.admin.dashboard.processMemory': '进程',
  'pages.admin.dashboard.cpu': 'CPU',
  'pages.admin.dashboard.cpu.cores': '核心数',
  'pages.admin.dashboard.cpu.user': '用户使用率',
  'pages.admin.dashboard.cpu.sys': '系统使用率',
  'pages.admin.dashboard.cpu.idle': '当前空闲率',
  'pages.admin.dashboard.memory': '内存',
  'pages.admin.dashboard.memory.total': '总内存',
  'pages.admin.dashboard.memory.used': '已用内存',
  'pages.admin.dashboard.memory.free': '剩余内存',
  'pages.admin.dashboard.memory.usage': '使用率',
  'pages.admin.dashboard.serverInfo': '服务器信息',
  'pages.admin.dashboard.host.name': '服务器名称',
  'pages.admin.dashboard.host.ip': '服务器IP',
  'pages.admin.dashboard.host.os': '操作系统',
  'pages.admin.dashboard.host.arch': '系统架构',
  'pages.admin.dashboard.runtimeInfo': '运行时信息',
  'pages.admin.dashboard.runtime.name': '运行时名称',
  'pages.admin.dashboard.runtime.version': '运行时版本',
  'pages.admin.dashboard.runtime.startTime': '启动时间',
  'pages.admin.dashboard.runtime.uptime': '运行时长',
  'pages.admin.dashboard.runtime.projectPath': '项目路径',
  'pages.admin.dashboard.runtime.executable': '可执行文件',
  'pages.admin.dashboard.runtime.goroutines': 'Goroutine 数',
  'pages.admin.dashboard.runtime.serverVersion': '服务版本',
  'pages.admin.dashboard.runtime.instanceId': '实例 ID',
  'pages.admin.dashboard.runtime.role': '运行角色',
  'pages.admin.dashboard.runtime.runArgs': '运行参数',
  'pages.admin.dashboard.businessSummary': '业务概览',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': '用户名',
  'pages.admin.user.phoneNumber': '手机号',
  'pages.admin.user.email': '邮箱',
  'pages.admin.user.status': '状态',
  'pages.admin.user.status.all': '所有',
  'pages.admin.user.status.disabled': '禁用',
  'pages.admin.user.status.normal': '正常',
  'pages.admin.user.quotaUsed': '每日已使用额度',
  'pages.admin.user.quotaTotal': '每日总额度',
  'pages.admin.user.createdAt': '创建时间',
  'pages.admin.user.operations': '操作',
  'pages.admin.user.edit': '编辑',
  'pages.admin.user.devices': '设备信息',
  'pages.admin.user.devicesModal.title': '{username} 的设备',
  'pages.admin.user.editModal.title': '编辑用户',
  'pages.admin.user.status.label': '用户状态',
  'pages.admin.user.status.enable': '启用',
  'pages.admin.user.status.disable': '禁用',
  'pages.admin.user.quotaUsed.label': '今日已用',
  'pages.admin.user.quotaTotal.label': '每日总额',
  'pages.admin.user.email.label': '邮箱',
  'pages.admin.user.save.success': '保存成功',
  'pages.admin.user.save.failed': '保存失败',
  'pages.admin.user.list.title': '用户列表',
  'pages.admin.user.create': '新增用户',
  'pages.admin.user.createModal.title': '新增用户',
  'pages.admin.user.create.success': '创建成功',
  'pages.admin.user.create.failed': '创建失败',
  'pages.admin.user.username.label': '账户名',
  'pages.admin.user.username.required': '请输入账户名',
  'pages.admin.user.username.min': '账户名至少2个字符',
  'pages.admin.user.password.label': '密码',
  'pages.admin.user.password.required': '请输入密码',
  'pages.admin.user.password.min': '密码至少6位',
  'pages.admin.user.phoneNumber.label': '手机号',
  'pages.admin.user.phoneNumber.invalid': '手机号格式不正确',
  'pages.admin.user.phoneNumber.placeholder': '选填，11位大陆手机号',
  'pages.admin.user.email.invalid': '邮箱格式不正确',
  'pages.admin.user.email.placeholder': '选填',
  'pages.admin.user.section.basic': '基本信息',
  'pages.admin.user.section.quota': '额度',
  'pages.admin.user.section.knowledgeBase': '知识库',
  'pages.admin.user.section.openapi': '开放平台',
  'pages.admin.user.section.security': '安全',
  'pages.admin.user.newPassword.extra': '留空则不修改密码',
  'pages.admin.user.newPassword.placeholder': '选填',
  'pages.admin.user.knowledgeBaseEnabled': '知识库',
  'pages.admin.user.knowledgeBase.on': '已开启',
  'pages.admin.user.knowledgeBase.off': '未开启',
  'pages.admin.user.knowledgeBaseMaxCount': '知识库数上限',
  'pages.admin.user.knowledgeBaseDocMaxCount': '单库文档上限',
  'pages.admin.user.knowledgeBaseEnabled.label': '允许使用',
  'pages.admin.user.knowledgeBaseMaxCount.label': '库数量上限',
  'pages.admin.user.knowledgeBaseDocMaxCount.label': '单库文档上限',
  'pages.admin.user.knowledgeBaseMaxCount.tooltip': '与系统配置取较小值',
  'pages.admin.user.knowledgeBaseDocMaxCount.tooltip': '与系统配置取较小值',
  // Admin Model Providers
  'pages.admin.providers.title': '模型供应商管理',
  'pages.admin.providers.total': '共 {total} 个供应商',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.statsTotal': '共 {n} 个供应商',
  'pages.admin.providers.loading': '正在加载模型供应商…',
  'pages.admin.providers.addNew': '添加新供应商',
  'pages.admin.providers.search.placeholder': '搜索供应商名称、端点或模型...',
  'pages.admin.providers.filter.all': '所有类型',
  'pages.admin.providers.filter.asr': 'ASR - 语音识别',
  'pages.admin.providers.filter.tts': 'TTS - 语音合成',
  'pages.admin.providers.filter.llm': 'LLM - 大语言模型',
  'pages.admin.providers.filter.vlllm': 'VLLLM - 视觉语言模型',
  'pages.admin.providers.empty.noProviders': '还没有任何供应商',
  'pages.admin.providers.empty.noMatches': '没有找到匹配的供应商',
  'pages.admin.providers.empty.addFirst': '点击上方按钮添加您的第一个模型供应商',
  'pages.admin.providers.empty.adjustFilters': '尝试调整搜索条件或筛选器',
  'pages.admin.providers.type.asr': 'ASR - 语音识别',
  'pages.admin.providers.type.tts': 'TTS - 语音合成',
  'pages.admin.providers.type.llm': 'LLM - 大语言模型',
  'pages.admin.providers.type.vlllm': 'VLLLM - 视觉语言模型',
  'pages.admin.providers.success.created': '供应商添加成功！',
  'pages.admin.providers.success.updated': '供应商更新成功！',
  'pages.admin.providers.success.deleted': '供应商删除成功！',
  'pages.admin.providers.success.statusToggled': '状态切换成功！',
  'pages.admin.providers.error.createFailed': '添加供应商失败，请重试',
  'pages.admin.providers.error.updateFailed': '更新供应商失败，请重试',
  'pages.admin.providers.error.deleteFailed': '删除供应商失败，请重试',
  'pages.admin.providers.error.testFailed': '测试连接失败，请检查网络或配置',
  'pages.admin.providers.error.toggleFailed': '切换状态失败，请重试',
  'pages.admin.providers.error.loadFailed': '加载供应商列表失败，请刷新页面重试',

  // Admin Settings
  'pages.admin.settings.title': '系统设置',
  'pages.admin.settings.asr.label': 'ASR 服务',
  'pages.admin.settings.asr.placeholder': '选择 ASR 服务',
  'pages.admin.settings.tts.label': 'TTS 服务',
  'pages.admin.settings.tts.placeholder': '选择 TTS 服务',
  'pages.admin.settings.llm.label': 'LLM 服务',
  'pages.admin.settings.llm.placeholder': '选择 LLM 服务',
  'pages.admin.settings.vlllm.label': 'VLLLM 服务',
  'pages.admin.settings.vlllm.placeholder': '选择 VLLLM 服务',
  'pages.admin.settings.prompt.label': '提示词设置(默认角色)',
  'pages.admin.settings.prompt.placeholder': '请输入系统提示词...',
  'pages.admin.settings.middleTierRole.label': '中间层提示词设置',
  'pages.admin.settings.middleTierRole.placeholder': '请输入中间层提示词...',
  'pages.admin.settings.visionPrompt.label': 'VLLM提示词设置',
  'pages.admin.settings.visionPrompt.placeholder': '请输入VLLM提示词...',
  'pages.admin.settings.quickReply.label': '快速回复词',
  'pages.admin.settings.quickReply.placeholder': '输入新的快速回复词',
  'pages.admin.settings.quickReply.add': '添加',
  'pages.admin.settings.deleteAudio.label': '删除音频',
  'pages.admin.settings.deleteAudio.enabled': '已开启',
  'pages.admin.settings.deleteAudio.disabled': '已关闭',
  'pages.admin.settings.usePrivateConfig': '使用私有配置',
  'pages.admin.settings.save': '保存配置',
  'pages.admin.settings.saving': '保存中...',
  'pages.admin.settings.reset': '重置',
  'pages.admin.settings.success.saved': '配置保存成功！',
  'pages.admin.settings.error.saveFailed': '保存配置失败，请重试',
  'pages.admin.settings.error.loadFailed': '加载配置失败，请刷新页面重试',

  // Add Device Dialog
  'pages.addDevice.modal.title': '添加设备',
  'pages.addDevice.verificationCode.label': '验证码：',
  'pages.addDevice.verificationCode.placeholder': '请输入设备播报的6位数验证码',
  'pages.addDevice.verificationCode.required': '请输入6位数字验证码',
  'pages.addDevice.verificationCode.error': '请输入6位数字验证码',

  // Provider Modal
  'pages.admin.providerModal.edit.title': '编辑供应商',
  'pages.admin.providerModal.add.title': '添加新供应商',
  'pages.admin.providerModal.name.label': '供应商名称 *',
  'pages.admin.providerModal.name.placeholder': '例如：OpenAI、豆包TTS',
  'pages.admin.providerModal.name.required': '请输入供应商名称',
  'pages.admin.providerModal.sort.label': '序号',
  'pages.admin.providerModal.sort.placeholder': '数字越小越靠前',
  'pages.admin.providerModal.validation.failed': '请检查必填项与配置是否正确（部分错误在对应字段下方）',
  'pages.admin.providerModal.type.label': '服务分类 *',
  'pages.admin.providerModal.subType.label': '具体类型 *',
  'pages.admin.providerModal.subType.required': '请选择具体类型',
  'pages.admin.providerModal.config.title': '配置信息',
  'pages.admin.providerModal.api.url.label': 'API地址 *',
  'pages.admin.providerModal.api.url.required': '请输入API地址',
  'pages.admin.providerModal.model.label': '模型 *',
  'pages.admin.providerModal.model.placeholder': '请输入模型名称',
  'pages.admin.providerModal.model.required': '请输入模型名称',
  'pages.admin.providerModal.model.name.label': '模型名称 *',
  'pages.admin.providerModal.model.name.required': '请输入模型名称',
  'pages.admin.providerModal.security.title': '安全设置',
  'pages.admin.providerModal.api.key.label': 'API密钥 *',
  'pages.admin.providerModal.api.key.required': '请输入API密钥',
  'pages.admin.providerModal.temperature.label': '温度 (0-2)',
  'pages.admin.providerModal.temperature.error': '温度值应在0-2之间',
  'pages.admin.providerModal.maxTokens.label': '最大令牌数',
  'pages.admin.providerModal.maxTokens.error': '最大令牌数应在1-32768之间',
  'pages.admin.providerModal.maxTokens.gtWindow': 'max_tokens（输出）不应大于 context_window（总容量），否则输入稍多时请求必超限',
  'pages.admin.providerModal.contextWindow.label': '上下文窗口 context_window',
  'pages.admin.providerModal.contextWindow.help': '模型上下文窗口（Token）：人设+历史+工具+回复的内容总上限，请按模型官方文档填写；填 0 表示未知，系统将按模型名称自动推断档位。该字段只用于上下文预算计算，不会发给模型。context_window=模型总容量（出厂固定，只登记）；max_tokens=分配给你的回复份额（可随时调小）。前者管能装多少，后者管回复多长。',
  'pages.admin.providerModal.contextWindow.preset': '快捷档位',
  'pages.admin.providerModal.contextWindow.hint': 'context_window=模型总容量（只登记）；max_tokens=回复份额（可调）。填 0 由系统按模型名推断档位。',
  'pages.admin.providerModal.contextWindow.budget': '按默认 70% 估算输入预算（实际以系统配置「窗口使用比例」为准，并会再减去 max_tokens）≈',
  'pages.admin.providerModal.contextWindow.error': '上下文窗口不能为负数',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': '应用ID *',
  'pages.admin.providerModal.appid.placeholder': '豆包应用ID',
  'pages.admin.providerModal.appid.required': '请输入应用ID',
  'pages.admin.providerModal.qwen.workspaceId.label': '应用ID (Workspace ID)',
  'pages.admin.providerModal.qwen.workspaceId.placeholder': 'llm-xxx（可选，百炼业务空间 ID）',
  'pages.admin.providerModal.accessToken.label': '访问令牌 *',
  'pages.admin.providerModal.accessToken.placeholder': '访问令牌',
  'pages.admin.providerModal.accessToken.required': '请输入访问令牌',
  'pages.admin.providerModal.cluster.label': '集群',
  'pages.admin.providerModal.grpc.host.label': 'gRPC主机 *',
  'pages.admin.providerModal.grpc.host.required': '请输入gRPC主机地址',
  'pages.admin.providerModal.grpc.port.label': 'gRPC端口 *',
  'pages.admin.providerModal.grpc.port.required': '请输入gRPC端口',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC地址（主机:端口）*',
  'pages.admin.providerModal.grpc.addr.required': '请输入gRPC地址（主机:端口）',
  'pages.admin.providerModal.funasr.addr.label': 'funasr 地址（host:port）*',
  'pages.admin.providerModal.funasr.addr.required': '请输入funasr uri（host:port）',
  'pages.admin.providerModal.voice.label': '音色 *',
  'pages.admin.providerModal.voice.required': '请输入语音类型',
  'pages.admin.providerModal.token.label': '令牌 *',
  'pages.admin.providerModal.token.placeholder': '豆包令牌',
  'pages.admin.providerModal.token.required': '请输入令牌',
  'pages.admin.providerModal.websocket.label': 'WebSocket地址 *',
  'pages.admin.providerModal.websocket.required': '请输入WebSocket地址',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'API密钥 *',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API密钥',
  'pages.admin.providerModal.siliconflow.apiKey.required': '请输入API密钥',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API地址',
  'pages.admin.providerModal.manage.voices': '管理音色',
  'pages.admin.providerModal.manageVoices': '管理音色',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS 无需额外配置',
  'pages.admin.providerModal.submit.error': '提交失败，请重试',

  // Provider Card
  'pages.admin.providerCard.status.active': '活跃',
  'pages.admin.providerCard.status.inactive': '离线',
  'pages.admin.providerCard.status.error': '错误',
  'pages.admin.providerCard.status.unknown': '未知',
  'pages.admin.providerCard.warning.readonly.test': '只读权限，无法测试供应商',
  'pages.admin.providerCard.warning.readonly.delete': '只读权限，无法删除供应商',
  'pages.admin.providerCard.warning.readonly.edit': '只读权限，无法编辑供应商',
  'pages.admin.providerCard.warning.readonly.toggle': '只读权限，无法切换状态',
  'pages.admin.providerCard.button.disable': '禁用',
  'pages.admin.providerCard.button.enable': '启用',
  'pages.admin.providerCard.button.testing': '测试中...',
  'pages.admin.providerCard.button.test': '测试',
  'pages.admin.providerCard.button.edit': '编辑',
  'pages.admin.providerCard.button.delete': '删除',
  'pages.admin.providerCard.delete.title': '确定要删除此项吗？',
  'pages.admin.providerCard.delete.content': '删除后无法恢复，请确认操作。',
  'pages.admin.providerCard.config.type': '类型',
  'pages.admin.providerCard.config.apiUrl': 'API地址',
  'pages.admin.providerCard.config.model': '模型',
  'pages.admin.providerCard.config.apiKey': 'API密钥',
  'pages.admin.providerCard.config.temperature': '温度',
  'pages.admin.providerCard.config.maxTokens': '最大tokens',
  'pages.admin.providerCard.config.contextWindow': '上下文窗口',
  'pages.admin.providerCard.config.appid': '应用ID',
  'pages.admin.providerCard.config.workspaceId': '应用ID',
  'pages.admin.providerCard.config.cluster': '集群',
  'pages.admin.providerCard.config.accessToken': '访问令牌',
  'pages.admin.providerCard.config.grpcHost': 'gRPC主机',
  'pages.admin.providerCard.config.grpcPort': 'gRPC端口',
  'pages.admin.providerCard.config.voice': '音色',
  'pages.admin.providerCard.config.format': '格式',
  'pages.admin.providerCard.config.token': '令牌',
  'pages.admin.providerCard.voices.supported': '支持的语音',
  'pages.admin.providerCard.voices.count': '个',
  'pages.admin.providerCard.voices.more': ' 等共 {n} 个',
  'pages.admin.providerCard.test.failed': '测试失败',

  // 白名单
  'pages.admin.whiteList.inputMac': '请输入mac地址',
  'pages.admin.whiteList.batchAdd': '批量添加',
  'pages.admin.whiteList.add': '添加',
  'pages.admin.whiteList.list.title': 'mac地址列表',
  'pages.admin.whiteList.selectCsvTip': '请选择一个csv文件',
  'pages.admin.whiteList.uploadSuccess': '上传成功',
  'pages.admin.whiteList.uploadFailed': '上传失败',
  'pages.admin.whiteList.invalidMac': '请输入有效的mac地址',

  // 运维管理 OpsManage
  'pages.admin.ops.service.title': '服务管理',
  'pages.admin.ops.upload.button': '上传服务文件',
  'pages.admin.ops.upload.success': '服务文件上传成功',
  'pages.admin.ops.upload.error': '服务文件上传失败',
  'pages.admin.ops.restart.button': '重启服务',
  'pages.admin.ops.restart.confirmTitle': '谨慎操作：确认要重启服务吗？',
  'pages.admin.ops.restart.desc': '重启服务将导致当前所有连接断开，服务将短暂不可用。',
  'pages.admin.ops.restart.warn': '此操作仅会关闭当前服务进程，请确保服务器已配置守护进程或自动重启脚本，否则服务将无法自动恢复！',
  'pages.admin.ops.restart.ok': '确认重启',
  'pages.admin.ops.restart.cancel': '取消',
  'pages.admin.ops.restart.success': '服务重启指令已发送',
  'pages.admin.ops.restart.error': '服务重启失败',
  'pages.admin.ops.log.title': '日志浏览与下载',
  'pages.admin.ops.web.upload.button': '上传 web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip 上传成功',
  'pages.admin.ops.web.upload.error': 'web.zip 上传失败',
  'pages.admin.ops.web.upload.onlyzip': '只允许上传 zip 文件',
  'pages.admin.ops.web.update.button': '更新 web 目录',
  'pages.admin.ops.web.update.success': 'web 目录更新指令已发送',
  'pages.admin.ops.web.update.error': 'web 目录更新失败',
  'pages.admin.ops.web.upload.onlywebzip': '只允许上传名为 web.zip 的文件',

  // 录音管理 RecorderManage
  'pages.admin.recorder.title': '设备录音管理',
  'pages.admin.settings.voiceCloneEnable': '启用声音克隆',
  'pages.admin.settings.voiceClone.placeholder': '声音克隆服务',
  'pages.admin.recorder.inputDeviceId': '请输入设备ID',
  'pages.admin.recorder.inputPlaceholder': '请输入设备ID',
  'pages.admin.recorder.search': '查询',
  'pages.admin.recorder.list.title': '录音列表',
  'pages.admin.recorder.fetchSuccess': '成功获取录音记录',
  'pages.admin.recorder.fetchError': '获取录音列表失败',
  'pages.admin.recorder.empty': '暂无录音数据，请输入设备ID查询',
  'pages.admin.recorder.totalCount': '统计信息',
  'pages.admin.recorder.conversationId': '会话ID',

  'pages.agentSetting.roleTemplate.empty': '暂无模板，请检查 role_template.json',
  'pages.admin.providerModal.save': '保存',
  'pages.admin.providerModal.copyAsNew': '复制为新的供应商',

  // 协约设备
  'pages.contractDevice.cardTitle': '协约设备管理',
  'pages.contractDevice.mac': 'MAC地址',
  'pages.contractDevice.protocolType': '协议类型',
  'pages.contractDevice.status': '状态',
  'pages.contractDevice.expireTime': '到期时间',
  'pages.contractDevice.updateTime': '更新时间',
  'pages.contractDevice.operations': '操作',
  'pages.contractDevice.edit': '编辑',
  'pages.contractDevice.delete': '删除',
  'pages.contractDevice.deleteConfirm': '确认删除',
  'pages.contractDevice.addTitle': '添加协约设备',
  'pages.contractDevice.batchAddTitle': '批量添加',
  'pages.contractDevice.editTitle': '编辑协约设备',
  'pages.contractDevice.listTitle': '协约设备列表',
  'pages.contractDevice.add': '添加',
  'pages.contractDevice.batchAdd': '批量添加',
  'pages.contractDevice.selectCsvTip': '请选择一个csv文件',
  'pages.contractDevice.uploadSuccess': '上传成功',
  'pages.contractDevice.macRequired': '请输入MAC地址',
  'pages.contractDevice.protocolTypeRequired': '请选择协议类型',
  'pages.contractDevice.statusRequired': '请选择状态',
  'pages.contractDevice.expireTimeRequired': '请选择到期时间',

  // 通用按钮和操作
  'pages.common.cancel': '取消',

  // 系统配置相关
  'pages.admin.systemConfig.roleName': '角色名称',
  'pages.admin.systemConfig.roleDesc': '角色描述',
  'pages.admin.systemConfig.enabled': '启用状态',
  'pages.admin.systemConfig.featureName': '功能名称',
  'pages.admin.systemConfig.featureDesc': '功能描述',
  'pages.admin.systemConfig.exitCommand': '退出指令',
  'pages.admin.systemConfig.mcpName': 'MCP名称',
  'pages.admin.systemConfig.newNameOptional': '新名称（可选）',
  'pages.admin.systemConfig.configJson': '配置JSON',
  'pages.admin.systemConfig.useDeviceCode': '使用设备代码',
  'pages.admin.systemConfig.quickReply': '快速回复',
  'pages.admin.systemConfig.shortTermMemory': '短期记忆',
  'pages.admin.systemConfig.saveUserAudio': '保存用户音频文件',
  'pages.admin.systemConfig.enableWhiteList': '启用白名单',
  'pages.admin.systemConfig.enhancedEmotionOutput': '增强情感输出',
  'pages.admin.systemConfig.emotionRecognitionGlobal': '回复语气情感增强全局开关',
  'pages.admin.systemConfig.speakerDetect': '声纹识别',
  'pages.admin.systemConfig.dialogGuardSection': '对话插话防护',
  'pages.admin.systemConfig.dialogGuardPipelineTitle': '各层作用与推荐设置（点开关旁 ? 看详情）',
  'pages.admin.systemConfig.dialogGuardEnabled': '统一防护总开关',
  'pages.admin.systemConfig.textHardRulesEnabled': '文本硬规则(L1)',
  'pages.admin.systemConfig.speakerGuardEnabled': '说话人硬门(L2)',
  'pages.admin.systemConfig.speakerHotReloadEnabled': '声纹热刷新',
  'pages.admin.systemConfig.speakerQualityCheck': '声纹录入质量预检',
  'pages.admin.systemConfig.speakerLockTtlSec': '锁定时长(秒)',
  'pages.admin.systemConfig.speakerLockTtlAfterTtsSec': 'TTS后续期(秒)',
  'pages.admin.systemConfig.speakerSwitchConfirmRounds': '换人确认轮次',
  'pages.admin.systemConfig.dialogGuardStats': '防护指标（本进程累计，重启清零）',
  'pages.admin.systemConfig.dialogGuardStatsDetail': '文本跳过 {skipText} · 插话跳过 {skipSpeaker} · 上下文跳过 {skipContext} · 回声跳过 {echoSkip} · 无回复声明 {noReply} · 声明过晚 {noReplyLate} · 高相关切换 {switchHigh} · 确认切换 {switchConfirm} · 疑似误拦 {suspect} · 质量拒录 {qualityReject}',
  'pages.admin.systemConfig.intentReplySection': '是否回复增强（热更新）',
  'pages.admin.systemConfig.intentReplyHotReloadHint': '以下为 L2.5 / L3，保存后即时生效（无需重启）。依赖上方「统一防护总开关」。',
  'pages.admin.systemConfig.intentReplyRelationHint': '关系：L2.5=进主对话前的廉价硬门；L3=主对话里的 dialog.no_reply。推荐两者都开，且「仅无声纹时注入」关闭——这样有 IntentMerge 时灰区交给模型，避免短语名单误杀。排查不回时搜日志 dialog_guard SKIP：layer=L2.5 是硬拦，layer=L3 是模型拒答。',
  'pages.admin.systemConfig.intentMergeEnabled': '并入主对话 L3(dialog.no_reply)',
  'pages.admin.systemConfig.intentMergeOnlyNoSpeaker': '仅无声纹时注入',
  'pages.admin.systemConfig.intentMergePrompt': '不回复提示词',
  'pages.admin.systemConfig.intentMergePromptPlaceholder': '服务端默认提示词',
  'pages.admin.systemConfig.contextGateEnabled': '上下文硬规则(L2.5)',
  'pages.admin.systemConfig.contextGateRecentTurns': '接续参考轮数',
  'pages.admin.systemConfig.contextGateShortCjk': 'CJK短句字数阈值',
  'pages.admin.systemConfig.contextGateShortLatin': '拉丁短句词数阈值',
  // L4 独立旁路（无用，已注释）
  // 'pages.admin.systemConfig.intentStandaloneEnabled': '独立旁路分类(L4)',
  // 'pages.admin.systemConfig.intentStandaloneMode': '旁路触发模式',
  // 'pages.admin.systemConfig.intentStandaloneMode.noSpeaker': '仅无声纹',
  // 'pages.admin.systemConfig.intentStandaloneMode.unlocked': '仅未锁定',
  // 'pages.admin.systemConfig.intentStandaloneMode.alwaysGray': '全灰区',
  // 'pages.admin.systemConfig.intentStandaloneHttpUrl': '旁路 HTTP 地址',
  // 'pages.admin.systemConfig.intentStandaloneTimeoutMs': '旁路超时(ms)',
  // 'pages.admin.systemConfig.intentStandaloneMinConfidence': '旁路最低置信度',
  'pages.admin.systemConfig.recorderManagerEnable': '启用录音管理',
  'pages.admin.systemConfig.voiceCloneEnable': '启用声音克隆',
  'pages.admin.systemConfig.flattenedChatHistory': '扁平化聊天历史',
  'pages.admin.systemConfig.dialogueHistoryLength': '对话历史长度',
  'pages.admin.systemConfig.userTotalQuota': '用户总额度',
  'pages.admin.systemConfig.dailyClearQuota': '每日清除配额',
  'pages.admin.systemConfig.checkDeviceModeImmediately': '立即检查设备模式',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': '新注册用户默认观察者角色',
  'pages.admin.systemConfig.status': '启用状态',
  'pages.admin.systemConfig.port': '端口',
  'pages.admin.systemConfig.udpShowPort': '显示端口',
  'pages.admin.systemConfig.accessToken': '访问令牌',
  'pages.admin.systemConfig.activateText': '激活文本',
  'pages.admin.systemConfig.logLevel': '日志级别',
  'pages.admin.systemConfig.logDir': '日志目录',
  'pages.admin.systemConfig.logFileName': '日志文件名',

  // 声音克隆相关
  'pages.console.voiceClone.name': '名称',
  'pages.console.voiceClone.provider': '提供商',
  'pages.console.voiceClone.mode': '模式',
  'pages.console.voiceClone.record': '录音',
  'pages.console.voiceClone.upload': '上传',

  // 声纹识别相关
  'pages.console.speakers.name': '名称',
  'pages.console.speakers.mode': '模式',
  'pages.console.speakers.record': '录音',
  'pages.console.speakers.upload': '上传',
  'pages.console.speakers.pageTip': '建议安静环境录制 2～5 秒有效语音；保存成功后无需设备重连即可识别（热刷新）。',
  'pages.console.speakers.recordTip': '请在安静环境、正常语速录制 2～5 秒；录入后当前在线设备会热刷新即时生效。',

  // 设置页面相关
  'pages.console.settings.email': '邮箱',
  'pages.console.settings.oldPassword': '旧密码',
  'pages.console.settings.newPassword': '新密码',
  'pages.console.settings.confirmNewPassword': '确认新密码',

  // VLLM提供商相关
  'pages.providers.vllm.maxPixels': '最大像素数',

  // 产品相关
  'pages.products.search.placeholder': '搜索产品',
  'pages.products.create.button': '新建产品',
  'pages.products.sort.id': '按ID排序',
  'pages.products.sort.updatedAt': '按最近修改',
  'pages.products.sort.lastConversationAt': '按最近对话',
  'pages.products.search.button': '查询',
  'pages.products.create.modal.title': '新建产品',
  'pages.products.create.modal.nameLabel': '产品名称',
  'pages.products.create.modal.descriptionLabel': '产品描述',
  'pages.products.create.modal.codecTypeLabel': '编解码器类型',
  'pages.products.create.modal.voiceEnabledLabel': '支持语音',
  'pages.products.create.modal.productKeyLabel': '产品标识',
  'pages.products.create.modal.deviceTypeLabel': '设备类型',
  'pages.products.create.modal.locationTypeLabel': '定位方式',
  'pages.products.create.modal.netTypeLabel': '网络类型',
  'pages.products.create.modal.imageLabel': '产品图片',
  'pages.products.create.success': '新建产品成功',
  'pages.products.create.failed': '新建产品失败',
  'pages.uploadImage.upload': '上传图片',

  // RoleTemplate 页面相关文本
  'pages.roleTemplate.modal.title': '角色模板',
  'pages.roleTemplate.add': '添加角色模板',
  'pages.roleTemplate.nameRequired': '请输入名称',
  'pages.roleTemplate.categoryRequired': '请输入分类',
  'pages.roleTemplate.promptRequired': '请输入角色介绍',
  'pages.roleTemplate.voiceRequired': '请输入声音',
  'pages.roleTemplate.voiceNameRequired': '请输入声音的名称',
  'pages.roleTemplate.message.Success': '保存成功',
  'pages.roleTemplate.presets.label': '多语言预设介绍',
  'pages.roleTemplate.presets.download': '下载导入模板',
  'pages.roleTemplate.presets.import': '批量导入',
  'pages.roleTemplate.presets.importPreview': '导入预览',
  'pages.roleTemplate.presets.confirmImport': '确认导入',
  'pages.roleTemplate.presets.fillLanguagePrompt': '请填写该语言角色介绍',
  'pages.roleTemplate.presets.needSaveFirst': '请先保存模板后再进行导入操作',
  'pages.roleTemplate.presets.downloadFail': '下载导入模板失败',
  'pages.roleTemplate.presets.saveWarn': '主表已保存，多语言预设写入失败，请重试编辑保存',
  'pages.roleTemplate.presets.importDone': '导入完成：成功 {imported}，跳过 {skipped}',
  'pages.roleTemplate.presets.col.row': '行',
  'pages.roleTemplate.presets.col.language': '语言',
  'pages.roleTemplate.presets.col.status': '状态',
  'pages.roleTemplate.presets.col.summary': '内容摘要',
  'pages.roleTemplate.presets.col.message': '说明',
  'pages.roleTemplate.presets.col.action': '操作',
  'pages.roleTemplate.presets.removeRow': '移除',
  'pages.roleTemplate.presets.nothingToImport': '没有可导入的行（可先移除错误行或重新上传）',
  'pages.roleTemplate.presets.status.create': '新增',
  'pages.roleTemplate.presets.status.update': '覆盖',
  'pages.roleTemplate.presets.status.error': '错误',
  'pages.roleTemplate.confirm.Delete': '确定删除这个角色模板吗？',
  'pages.roleTemplate.column.ID': 'ID',
  'pages.roleTemplate.column.Name': '名称',
  'pages.roleTemplate.column.Description': '描述',
  'pages.roleTemplate.column.Category': '分类',
  'pages.roleTemplate.column.ASR': '语音识别',
  'pages.roleTemplate.column.LLM': '大模型',
  'pages.roleTemplate.column.TTS': '语音合成模型',
  'pages.roleTemplate.column.Sort': '排序',
  'pages.roleTemplate.column.Prompt': '角色介绍',
  'pages.roleTemplate.column.Voice': '语音',
  'pages.roleTemplate.column.VoiceName': '语音名称',
  'pages.roleTemplate.column.UpdatedAt': '更新时间',
  'pages.roleTemplate.column.CreatedAt': '创建时间',
  'pages.roleTemplate.column.Operation': '操作',
  'pages.roleTemplate.column.Model': '模型管理',
  'pages.roleTemplate.column.voice': '声音',
  'pages.roleTemplate.column.voiceName': '声音名称',
  'pages.roleTemplate.column.category': '分类',
  'pages.roleTemplate.column.prompt': '角色介绍',
  'pages.roleTemplate.column.Avatar': '头像',
  'pages.roleTemplate.column.Language': '对话语言',
  'pages.roleTemplate.column.asrSpeed': '语音识别速度',
  'pages.roleTemplate.column.speakSpeed': '角色语速',
  'pages.roleTemplate.column.tone': '语调',
  'pages.roleTemplate.column.ProductFlag': '产品标志',
  'pages.roleTemplate.column.tenantCode': '所属代理商',
  'pages.roleTemplate.column.tenantCodeTip': '不选则为平台公共模板；代理商账号新建时由服务端自动写入其 supplier_code',

  // ProductCategory 页面相关文本
  'pages.productCategory.modal.title': '产品分类',
  'pages.productCategory.add': '添加分类',
  'pages.productCategory.column.Name': '名称',
  'pages.productCategory.column.roleTplId': '角色模板ID',
  'pages.productCategory.column.roleTplName': '角色模板名称',
  'pages.productCategory.column.roleTplId.placeholder': '请选择角色模板',
  'pages.productCategory.column.roleTplName.placeholder': '请输入角色模板名称',
  'pages.productCategory.column.ProductCategory': '产品设备型号',
  'pages.productCategory.column.Description': '描述',
  'pages.productCategory.column.status': '状态',
  'pages.productCategory.column.sort': '排序',
  'pages.productCategory.column.updatedAt': '更新时间',
  'pages.productCategory.column.CreatedAt': '创建时间',
  'pages.productCategory.column.Operation': '操作',
  'pages.productCategory.action.productionTokenManage': '产线 Token 授权',
  'pages.productCategory.action.firmwareManage': '产品固件',
  'pages.productCategory.firmware.drawerTitle': '产品固件管理',
  'pages.productCategory.firmware.categoryLabel': '产品分类',
  'pages.productCategory.firmware.boardLabel': '主板型号',
  'pages.productCategory.firmware.noBoardModel': '请先在分类中填写「产品设备型号」，否则无法上传产线固件。',
  'pages.productCategory.firmware.defaultExplain': '未指定「默认」时，产线 GenerateLicense 按版本号自动取最新；可手动指定默认版本。首条上传会自动设为默认。',
  'pages.productCategory.firmware.addTitle': '新增固件',
  'pages.productCategory.firmware.displayName': '固件名称',
  'pages.productCategory.firmware.nameRequired': '请输入固件名称',
  'pages.productCategory.firmware.namePh': '如：正式版 2025Q1',
  'pages.productCategory.firmware.version': '版本号',
  'pages.productCategory.firmware.versionRequired': '请输入版本号 x.y.z.w',
  'pages.productCategory.firmware.versionFormat': '版本号须为 x.y.z.w',
  'pages.productCategory.firmware.file': '固件文件',
  'pages.productCategory.firmware.selectBin': '选择 .bin 固件（文件名不必与版本号一致）',
  'pages.productCategory.firmware.upload': '上传',
  'pages.productCategory.firmware.listTitle': '固件列表',
  'pages.productCategory.firmware.colName': '固件名称',
  'pages.productCategory.firmware.colUploadedAt': '上传时间',
  'pages.productCategory.firmware.colVersion': '版本号',
  'pages.productCategory.firmware.colBoard': '主板型号',
  'pages.productCategory.firmware.colDefault': '默认下载',
  'pages.productCategory.firmware.defaultTag': '默认',
  'pages.productCategory.firmware.setDefault': '设为默认',
  'pages.productCategory.firmware.loadFailed': '加载失败',
  'pages.productCategory.firmware.needFile': '请选择 .bin 固件文件',
  'pages.productCategory.firmware.filenameHint': '上传文件名可与版本号不一致；服务端按表单版本号保存为 {版本}.bin',
  'pages.productCategory.firmware.uploadOk': '上传成功',
  'pages.productCategory.firmware.uploadFailed': '上传失败',
  'pages.productCategory.firmware.defaultOk': '已设为默认版本',
  'pages.productCategory.firmware.defaultFailed': '设置失败',
  'pages.productCategory.column.tenantCode': '所属代理商',
  'pages.productCategory.column.tenantCodeTip': '不选则为平台公共分类；代理商账号新建时由服务端自动写入其 supplier_code',
  'pages.productCategory.column.imageUrl': '分类图片',
  'pages.productCategory.column.animationVideoUrl': '绑定动画视频',
  'pages.productCategory.column.wakeWord': '唤醒词',
  'pages.productCategory.column.wakeWordPlaceholder': '多个唤醒词用英文逗号隔开，默认：你好小智,Jarvis',
  'pages.productCategory.upload.imageHint': '仅 PNG，最大 1MB，上传至 OSS',
  'pages.productCategory.upload.videoHint': '仅 MP4，最大 10MB，上传至 OSS',
  'pages.productCategory.confirm.Delete': '确定删除这个产品分类吗？',
  'pages.productCategory.deleteSuccess': '删除成功',
  'pages.productCategory.deleteFailed': '删除失败',
  'pages.productCategory.createSuccess': '保存成功',
  'pages.productCategory.createFailed': '保存失败',

  // 知识库相关
  'pages.knowledgeBase.page.title': '知识库',
  'pages.knowledgeBase.page.tip':
    '每个用户最多 {maxKb} 个知识库，每个知识库最多 {maxDoc} 个文档；实际生效值为系统 mcp_rag 配置与用户阶梯额度中的较小者。',
  'pages.knowledgeBase.page.disabledAlert':
    '当前账号未开通知识库功能，仅可查看与删除；创建、编辑、上传与切片管理请在管理后台为用户开启「允许使用知识库」。',
  'pages.knowledgeBase.page.archiveTip':
    '当前已开启知识库上传原始文件归档：服务端会按用户、知识库与时间分目录保留上传文件副本，便于追溯。',
  'pages.knowledgeBase.list.error': '获取知识库列表失败',
  'pages.knowledgeBase.columns.name': '知识库名称',
  'pages.knowledgeBase.columns.description': '知识库描述',
  'pages.knowledgeBase.columns.documentCount': '文档数量',
  'pages.knowledgeBase.columns.state': '状态',
  'pages.knowledgeBase.columns.createdAt': '创建时间',
  'pages.knowledgeBase.columns.actions': '操作',
  'pages.knowledgeBase.actions.view': '查看',
  'pages.knowledgeBase.actions.edit': '编辑',
  'pages.knowledgeBase.actions.upload': '上传文档',
  'pages.knowledgeBase.actions.delete': '删除',
  'pages.knowledgeBase.actions.recallTest': '召回测试',
  'pages.knowledgeBase.recall.modalTitle': '召回测试 — {name}',
  'pages.knowledgeBase.recall.tip': '输入问题或关键词，在当前知识库已向量化文档中检索最相关切片，用于验证召回效果。',
  'pages.knowledgeBase.recall.queryPlaceholder': '输入检索内容，按 Enter 执行',
  'pages.knowledgeBase.recall.queryRequired': '请输入检索内容',
  'pages.knowledgeBase.recall.search': '检索',
  'pages.knowledgeBase.recall.error': '检索失败',
  'pages.knowledgeBase.recall.summary': '摘要',
  'pages.knowledgeBase.recall.hitCount': '共 {count} 条命中',
  'pages.knowledgeBase.recall.empty': '未检索到相关内容，可尝试更换关键词或确认文档已完成索引',
  'pages.knowledgeBase.recall.score': '融合分',
  'pages.knowledgeBase.recall.chunkIndex': '切片',
  'pages.knowledgeBase.state.enabled': '开启',
  'pages.knowledgeBase.state.disabled': '关闭',
  'pages.knowledgeBase.state.draft': '未上传',
  'pages.knowledgeBase.create.button': '新建知识库',
  'pages.knowledgeBase.create.modalTitle': '新建知识库',
  'pages.knowledgeBase.create.success': '创建成功',
  'pages.knowledgeBase.edit.modalTitle': '编辑知识库',
  'pages.knowledgeBase.edit.success': '更新成功',
  'pages.knowledgeBase.save.error': '保存失败',
  'pages.knowledgeBase.form.name': '知识库名称',
  'pages.knowledgeBase.form.nameRequired': '请输入知识库名称',
  'pages.knowledgeBase.form.namePlaceholder': '请输入知识库名称',
  'pages.knowledgeBase.form.description': '知识库描述',
  'pages.knowledgeBase.form.descriptionRequired': '请输入知识库描述',
  'pages.knowledgeBase.form.descriptionPlaceholder': '请输入知识库描述',
  'pages.knowledgeBase.upload.modalTitle': '上传文档',
  'pages.knowledgeBase.upload.modalTip': '单个文件不超过 15MB；该知识库文档总数受系统配置限制（当前上限 {n}）。',
  'pages.knowledgeBase.upload.docLimit': '已达到该知识库文档数量上限（{n}），请先删除部分文档',
  'pages.knowledgeBase.upload.selectButton': '选择 txt、md、pdf 或 docx 文件',
  'pages.knowledgeBase.upload.required': '请选择文档',
  'pages.knowledgeBase.upload.success': '上传成功',
  'pages.knowledgeBase.upload.accepted': '上传成功，文档正在后台解析，列表将自动更新状态。',
  'pages.knowledgeBase.upload.indexError': '文档解析失败',
  'pages.knowledgeBase.upload.phase.uploading': '正在上传文件…',
  'pages.knowledgeBase.upload.error': '上传失败',
  'pages.knowledgeBase.upload.typeError': '仅支持 txt、md、pdf、docx 文件',
  'pages.knowledgeBase.upload.sizeError': '文件大小不能超过 15MB',
  'pages.knowledgeBase.upload.singleLimit': '当前版本仅支持一个文档，请先删除现有文档',
  'pages.knowledgeBase.delete.confirmTitle': '确认删除知识库',
  'pages.knowledgeBase.delete.success': '删除成功',

  // 知识库文档相关
  'pages.knowledgeBase.documents.page.title': '知识库文档',
  'pages.knowledgeBase.documents.archiveAlert':
    '当前系统已开启知识库上传原始文件归档，您上传的文件副本会按用户与知识库分目录保存在服务器指定路径。',
  'pages.knowledgeBase.documents.list.error': '获取文档列表失败',
  'pages.knowledgeBase.documents.columns.name': '文档名字',
  'pages.knowledgeBase.documents.columns.state': '状态',
  'pages.knowledgeBase.documents.state.processing': '解析中',
  'pages.knowledgeBase.documents.state.failed': '失败',
  'pages.knowledgeBase.documents.state.ready': '解析成功',
  'pages.knowledgeBase.documents.columns.ragStoredFilename': 'RAG 存储文件名',
  'pages.knowledgeBase.documents.columns.size': '文件大小',
  'pages.knowledgeBase.documents.columns.createdAt': '创建时间',
  'pages.knowledgeBase.documents.columns.actions': '操作',
  'pages.knowledgeBase.documents.actions.viewChunks': '查看切片',
  'pages.knowledgeBase.documents.delete.confirmTitle': '确认删除文档',
  'pages.knowledgeBase.documents.delete.success': '删除成功',

  // 知识库切片相关
  'pages.knowledgeBase.chunks.page.title': '知识库切片',
  'pages.knowledgeBase.chunks.list.error': '获取切片列表失败',
  'pages.knowledgeBase.chunks.columns.index': '序号',
  'pages.knowledgeBase.chunks.columns.content': '内容',
  'pages.knowledgeBase.chunks.columns.metadata': '元数据',
  'pages.knowledgeBase.chunks.columns.actions': '操作',
  'pages.knowledgeBase.chunks.actions.edit': '编辑',
  'pages.knowledgeBase.chunks.actions.save': '保存',
  'pages.knowledgeBase.chunks.edit.contentRequired': '内容不能为空',
  'pages.knowledgeBase.chunks.edit.success': '更新成功',
  'pages.knowledgeBase.chunks.edit.error': '更新失败',
  'pages.knowledgeBase.chunks.metadata.filename': '文件:',
  'pages.knowledgeBase.chunks.metadata.chars': '字符数:',
  'pages.knowledgeBase.chunks.metadata.words': '词数:',
  'pages.knowledgeBase.chunks.metadata.lines': '行数:',
  'pages.knowledgeBase.chunks.metadata.createdAt': '创建时间:',
  'pages.knowledgeBase.chunks.metadata.updatedAt': '更新时间:',
  'pages.knowledgeBase.chunks.sort.desc': '按创建时间：新→旧（点击切换为升序）',
  'pages.knowledgeBase.chunks.sort.asc': '按创建时间：旧→新（点击切换为降序）',
  'pages.knowledgeBase.chunks.pagination.total': '共 {total} 条',
};


